class ProductBundle {
    constructor() {
      this.selectors = {
        bundleSelector: '.product-bundle-selector',
        colorButtons: '.bundle-color-select-button',
        colorItems: '.bundle-color-item',
        bundleDrawer: '#BundleColorDrawer',
        drawerOverlay: '#BundleColorDrawer-Overlay',
        drawerClose: '[data-close-drawer]',
        bundleAddToCart: '#bundle-add-to-cart',
        colorGrid: '.bundle-color-grid',
        loadingOverlay: '.bundle-color-loading',
        drawerTitle: '#bundle-drawer-title',
        productGrid: '.bundle-color-product-grid',
        searchIcon: '.search-icon',
        searchContainer: '.bundle-search-container',
        searchInput: '.bundle-search-input',
        searchButton: '.bundle-search-button'
      };
  
      this.state = {
        currentColorPosition: null,
        isRequired: false,
        selectedColors: {},
        productId: null,
        drawerOpen: false,
        colorsCollection: null, // Collection for required/compulsory colors
        optionalColorsCollection: null, // Collection for optional colors
        requiredHandleSuffix: 'free', // Suffix to add to required color handles
        productsPerRow: 2,
        showPrices: true,
        searchActive: false,
        searchQuery: '',
        preferenceActive: false,
        activeFilters: {
          color: [],
          style: []
        },
        productImages: [],
        currentImageIndex: 0,
        currentQuickViewProduct: null,
        filtersApplied: false, // NEW: Flag to track if filters are applied
        colorLabelPrefix: 'Design', // NEW: Store the color label prefix from theme settings
        optionalColorLabel: 'Optional design', // NEW: Store the optional color label from theme settings
        chooseColorTextTemplate: '', // Will be set from theme settings in init()
        drawerTitleTemplate: '', // Will be set from theme settings in init()
        drawerTitleOptionalTemplate: '', // Will be set from theme settings in init()
        addToCartButtonText: '', // NEW: Store the add to cart button text from theme settings
        designFilterLabel: '', // NEW: Store the design filter label from theme settings
        styleFilterLabel: '', // NEW: Store the style filter label from theme settings
        clearFiltersText: '', // NEW: Store the clear filters text from theme settings
        searchPlaceholder: '', // NEW: Store the search placeholder text from theme settings
        searchButtonText: '', // NEW: Store the search button text from theme settings
        quickViewButtonText: '', // NEW: Store the quick view button text from theme settings
        selectButtonText: '', // NEW: Store the select button text from theme settings
        outOfStockText: '', // NEW: Store the out of stock text from theme settings
        cartButtonColor: '#000000', // NEW: Store the cart button color from theme settings
        cartButtonTextColor: '#ffffff', // NEW: Store the cart button text color from theme settings
        mainProductPrice: 0 // NEW: Store the main product price for bundle price calculation
      };
  
      this.productJson = null;
      this.priceUpdatePending = false;
      this.justRemovedCompulsoryColorIds = [];
      this.removedColorIds = new Set();
  
      this.init();
    }
  
    init() {
      // Set the product ID and configuration options
      const bundleContainer = document.querySelector(this.selectors.bundleSelector);
      if (!bundleContainer) return;
      
      // Listen for variant changes on the product form
      this.listenForVariantChanges();
      
      // Get product ID
      this.state.productId = bundleContainer.dataset.productId;
      
      // Get choose color text template from data attribute (new)
      this.state.chooseColorTextTemplate = bundleContainer.dataset.chooseColorText || 'Choose Color [position]';
      // Decode HTML entities if present
      this.state.chooseColorTextTemplate = this.state.chooseColorTextTemplate
        .replace(/&#91;/g, '[')
        .replace(/&#93;/g, ']');
      
      // Get drawer title template from data attribute (new)
      this.state.drawerTitleTemplate = bundleContainer.dataset.drawerTitle || 'Choose Color';
      
      // Get optional drawer title template from data attribute (new)
      this.state.drawerTitleOptionalTemplate = bundleContainer.dataset.drawerTitleOptional || 'Choose Optional Design [position]';
      // Decode HTML entities if present
      this.state.drawerTitleOptionalTemplate = this.state.drawerTitleOptionalTemplate
        .replace(/&#91;/g, '[')
        .replace(/&#93;/g, ']');
      
      // Get UI text customization settings
      this.state.designFilterLabel = bundleContainer.dataset.designFilterLabel || 'Design:';
      this.state.styleFilterLabel = bundleContainer.dataset.styleFilterLabel || 'Style:';
      this.state.clearFiltersText = bundleContainer.dataset.clearFiltersText || 'Clear Filters';
      this.state.searchPlaceholder = bundleContainer.dataset.searchPlaceholder || 'Search';
      this.state.searchButtonText = bundleContainer.dataset.searchButtonText || 'Search';
      this.state.quickViewButtonText = bundleContainer.dataset.quickViewText || 'Quick View';
      this.state.selectButtonText = bundleContainer.dataset.selectButtonText || 'Select';
      this.state.addToCartButtonText = bundleContainer.dataset.buttonText || 'Add to Cart';
      this.state.outOfStockText = bundleContainer.dataset.outOfStockText || 'Out of Stock';
      
      // Get button color settings
      this.state.cartButtonColor = bundleContainer.dataset.cartButtonColor || '#000000';
      this.state.cartButtonTextColor = bundleContainer.dataset.cartButtonTextColor || '#ffffff';
      
      // Get variant color counts if available
      if (bundleContainer.dataset.variantColorCounts) {
        try {
          // Log the raw data from the attribute for debugging
    
          
          // Try to process the data in different ways since it might be already a JSON object or a string
          const rawData = bundleContainer.dataset.variantColorCounts;
          
          // Try different approaches to parse the data
          if (typeof rawData === 'object' && rawData !== null) {
            // Data is already an object
            this.state.variantColorCounts = rawData;
          } else if (rawData.startsWith('{') && rawData.endsWith('}')) {
            // Try parsing as JSON
            this.state.variantColorCounts = JSON.parse(rawData);
          } else {
            // Sometimes Liquid escapes it strangely, try to clean it up
            const cleanedData = rawData.replace(/\"|\\"/g, '"').trim();
            if (cleanedData.startsWith('{') && cleanedData.endsWith('}')) {
              this.state.variantColorCounts = JSON.parse(cleanedData);
            } else {
              console.warn('Unable to parse variant color counts data after cleaning');
              this.state.variantColorCounts = {};
            }
          }
          
    
          
          // Check if the object is empty
          const hasCountMappings = Object.keys(this.state.variantColorCounts).length > 0;
    
          
        } catch (e) {
          console.error('Error parsing variant color counts:', e);
          console.error('Raw data that caused the error:', bundleContainer.dataset.variantColorCounts);
          this.state.variantColorCounts = {};
        }
      } else {
  
        this.state.variantColorCounts = {};
      }
      
      // Get collection ID for color selection
      this.state.colorsCollection = bundleContainer.dataset.collectionId;
      this.state.optionalColorsCollection = bundleContainer.dataset.optionalCollectionId;
      this.state.requiredHandleSuffix = bundleContainer.dataset.requiredHandleSuffix || 'free';
      
      // Check if we have products per row setting
      const productsPerRow = bundleContainer.dataset.productsPerRow;
      if (productsPerRow) {
        this.state.productsPerRow = parseInt(productsPerRow, 10);
      }
      
      // Check price display setting
      this.state.showPrices = (bundleContainer.dataset.showPrices === 'true');
      this.state.showQuickView = (bundleContainer.dataset.showQuickView === 'true');
      
      // Set default max optional colors if not specified
      this.state.maxOptionalColors = 9; // Default to 9 optional colors max
      
      // Track which optional color boxes are dynamically added (vs. from the template)
      this.state.dynamicOptionalBoxes = [];
      
      // Initialize dynamic optional colors state from bundle settings
      const optionalSection = document.querySelector('.bundle-optional-section');
      if (optionalSection) {
        // Try to get the max optional colors from the data attribute on the section if available
        if (optionalSection.dataset.maxOptional) {
          this.state.maxOptionalColors = parseInt(optionalSection.dataset.maxOptional, 10);
        }
        
        // Get the current count of optional colors
        const optionalItems = optionalSection.querySelectorAll('.bundle-color-item.optional-color');
        this.state.initialOptionalCount = optionalItems.length;
        
        // Initialize the optional colors grid layout based on count (for desktop)
        this.updateOptionalColorsLayout(optionalItems.length);
        
        // Store the optional color label if available
        if (optionalItems.length > 0) {
          const firstOptional = optionalItems[0];
          const nameElement = firstOptional.querySelector('.bundle-color-name');
          if (nameElement) {
            this.state.optionalColorLabel = nameElement.textContent || 'Optional design';
          }
        }
        
  
      }
      
      // Get the color label prefix from a required color box if available
      const requiredItems = document.querySelectorAll('.bundle-color-item.required-color');
      if (requiredItems.length > 0) {
        const firstRequired = requiredItems[0];
        const nameElement = firstRequired.querySelector('.bundle-color-name');
        if (nameElement) {
          const nameParts = nameElement.textContent.trim().split(' ');
          // The last part is usually the number, so remove it to get the prefix
          if (nameParts.length > 1) {
            nameParts.pop(); // Remove the last element (number)
            this.state.colorLabelPrefix = nameParts.join(' '); // Join the rest back
      
          }
        }
      }
      
      // Hide price elements if showPrices is false
      if (!this.state.showPrices) {
        bundleContainer.classList.add('bundle-selector-hide-prices');
      }
      
      if (!this.state.showQuickView) {
        bundleContainer.classList.add('bundle-selector-hide-quick-view');
      }
      

      
      // Create the quick view modal if enabled
      if (this.state.showQuickView) {
        this.createQuickViewModal();
      }
      
      // Add event listeners
      this.addEventListeners();
      
      // Listen for variant changes
      this.listenForVariantChanges();
      
      // Update button text based on selections
      this.updateActionButton();
      
      // Fetch product JSON for accurate variant pricing
      this.fetchProductJson();
      
      // Ensure currentVariantId is set at init
      if (!this.state.currentVariantId) {
        if (window.Shopify && window.Shopify.currentVariant && window.Shopify.currentVariant.id) {
          this.state.currentVariantId = window.Shopify.currentVariant.id;
    
        }
      }
    }
  
    // Universal Shopify price formatter
    formatPrice(cents) {
      // Use Shopify's built-in formatMoney if available
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      
      // Improved fallback with proper currency detection
      try {
        // Try to get currency from the page/DOM
        let currencySymbol = '$'; // Default to USD as fallback
        
        // Method 1: Try to get from meta tag (most themes have this)
        const currencyMeta = document.querySelector('meta[property="og:price:currency"]');
        if (currencyMeta) {
          const currency = currencyMeta.getAttribute('content');
          // Simple mapping of common currency codes to symbols
          const currencyMap = {
            'USD': '$', 'EUR': '€', 'GBP': '£', 'CAD': 'CA$', 
            'AUD': 'A$', 'JPY': '¥', 'CNY': '¥', 'INR': '₹'
          };
          currencySymbol = currencyMap[currency] || currency + ' ';
        } 
        // Method 2: Look for currency elements on the page
        else {
          const priceElements = document.querySelectorAll('.price:not(.price--compare)');
          if (priceElements.length > 0) {
            const priceText = priceElements[0].textContent.trim();
            currencySymbol = priceText.replace(/[0-9.,\s]/g, '').split('')[0] || '$';
          }
        }
        
        // Format with the detected currency and appropriate decimal/thousand separators
        const amount = (cents / 100).toFixed(2);
        return currencySymbol + amount;
      } catch (e) {
        console.error('Error in price formatting:', e);
        // Ultra simple fallback if all else fails
        return '$' + (cents / 100).toFixed(2);
      }
    }
    
    // Enhanced price formatter that respects theme settings for currency and decimals
    getFormattedPrice(cents) {
      // First try to clone the exact format from an existing price on the page
      try {
        const existingFormat = this.getExistingPriceFormat();
        if (existingFormat && existingFormat.originalFormat) {
          // We have a complete sample price format to clone

          
          // Extract the numeric part from the original format
          const numericMatch = existingFormat.originalFormat.match(/[\d]+(?:[.,]\d+)?/);
          if (numericMatch && numericMatch[0]) {
            const originalNumeric = numericMatch[0];
            const originalAmount = parseFloat(originalNumeric.replace(/,/g, '.'));
            
            if (!isNaN(originalAmount) && originalAmount > 0) {
              // Format the new amount in the same style as the original
              const newAmount = cents / 100;
              let formattedAmount;
              
              // Check if original has decimals
              if (existingFormat.hasDecimals) {
                // Format with same decimal places as original
                const decimalPart = originalNumeric.match(/[.,](\d+)/);
                const decimalPlaces = decimalPart ? decimalPart[1].length : 2;
                formattedAmount = newAmount.toFixed(decimalPlaces);
                
                // Use the same decimal separator as the original
                if (originalNumeric.includes(',')) {
                  formattedAmount = formattedAmount.replace('.', ',');
                }
              } else {
                // No decimals in original - use ceiling to round up
                formattedAmount = Math.ceil(newAmount).toString();
              }
              
              // Replace the numeric part in the original format
              const newPrice = existingFormat.originalFormat.replace(originalNumeric, formattedAmount);

              return newPrice;
            }
          }
        }
      } catch (e) {

      }
      
      // If we couldn't clone the exact format, use our improved detection
      const showDecimals = this.shouldShowDecimals();
      const currencyInfo = this.detectCurrencyInfo();
      
      // Use Shopify's built-in formatMoney if available
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        // If we have money format strings available
        if (window.Shopify.moneyFormat) {
          // If we should hide decimals, modify the format string
          if (!showDecimals && window.Shopify.moneyFormat.includes('.')) {
            const modifiedFormat = window.Shopify.moneyFormat
              .replace(/\{\{\s*amount\s*\}\}/g, '{{amount_no_decimals}}')
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, '{{amount_no_decimals_with_comma_separator}}');
            return window.Shopify.formatMoney(cents, modifiedFormat);
          }
          return window.Shopify.formatMoney(cents, window.Shopify.moneyFormat);
        }
        
        // If no specific format is available, use default formatMoney
        return window.Shopify.formatMoney(cents);
      }
      
      // If Shopify's formatMoney is not available, use our own formatting
      try {
        // Format the amount with or without decimals
        let amount;
        if (showDecimals) {
          amount = (cents / 100).toFixed(2);
        } else {
          amount = Math.floor(cents / 100).toString();
        }
        
        // Apply currency in the correct position with a space
        return currencyInfo.position === 'before' ? 
          currencyInfo.symbol + ' ' + amount : 
          amount + ' ' + currencyInfo.symbol;
      } catch (e) {

        // Fall back to the original formatPrice method
        return this.formatPrice(cents);
      }
    }
    
    // Helper method to determine if decimals should be shown
    shouldShowDecimals() {
      // First try to get format from existing price format
      const existingFormat = this.getExistingPriceFormat();
      if (existingFormat && existingFormat.hasDecimals !== undefined) {
        return existingFormat.hasDecimals;
      }
      
      // Check existing price elements for decimal pattern as fallback
      const priceElements = document.querySelectorAll('.price-item--regular, .price-item--sale');
      if (priceElements.length > 0) {
        const priceText = priceElements[0].textContent.trim();
        // Check if price has decimals (both dot and comma decimal separators)
        return /[\.,]\d{1,2}/.test(priceText);
      }
      
      return true; // Default to showing decimals
    }
    
    // Helper method to detect currency symbol and position
    detectCurrencyInfo() {
      let symbol = '$'; // Default symbol
      let position = 'before'; // Default position
      
      // First try to get an exact sample from the page
      const existingFormat = this.getExistingPriceFormat();
      if (existingFormat) {

        return existingFormat;
      }
      
      // Try to detect from existing price elements as fallback
      const priceElements = document.querySelectorAll('.price-item--regular, .price-item--sale');
      if (priceElements.length > 0) {
        const priceText = priceElements[0].textContent.trim();

        
        // More precise regex to match numbers with or without decimals
        const numericMatch = priceText.match(/[\d]+(?:[.,]\d+)?/);
        
        if (numericMatch && numericMatch[0]) {
          const numericPart = numericMatch[0];
          const numericIndex = priceText.indexOf(numericPart);
          const beforeNumeric = priceText.substring(0, numericIndex).trim();
          const afterNumeric = priceText.substring(numericIndex + numericPart.length).trim();
          

          
          // Determine currency position
          if (beforeNumeric && !afterNumeric) {
            symbol = beforeNumeric;
            position = 'before';
          } else if (!beforeNumeric && afterNumeric) {
            symbol = afterNumeric;
            position = 'after';
          } else if (beforeNumeric && afterNumeric) {
            // If currency appears on both sides, check which one is likely the symbol
            // Currency symbols are typically non-alphanumeric or 3-letter codes
            const beforeIsSymbol = /^[^\w\d\s]|[A-Z]{3}$/.test(beforeNumeric.trim());
            const afterIsSymbol = /^[^\w\d\s]|[A-Z]{3}$/.test(afterNumeric.trim());
            
            if (beforeIsSymbol && !afterIsSymbol) {
              symbol = beforeNumeric;
              position = 'before';
            } else if (!beforeIsSymbol && afterIsSymbol) {
              symbol = afterNumeric;
              position = 'after';
            } else {
              // If both could be symbols, prefer the one that's a single character
              if (beforeNumeric.trim().length === 1) {
                symbol = beforeNumeric;
                position = 'before';
              } else if (afterNumeric.trim().length === 1) {
                symbol = afterNumeric;
                position = 'after';
              } else {
                // Default to the first one
                symbol = beforeNumeric;
                position = 'before';
              }
            }
          }
        }
      } else {
        // Fallback to meta tag
        const currencyMeta = document.querySelector('meta[property="og:price:currency"]');
        if (currencyMeta) {
          const currency = currencyMeta.getAttribute('content');
          const currencyMap = {
            'USD': '$', 'EUR': '€', 'GBP': '£', 'CAD': 'CA$', 
            'AUD': 'A$', 'JPY': '¥', 'CNY': '¥', 'INR': '₹'
          };
          symbol = currencyMap[currency] || currency + ' ';
        }
      }
      

      return { symbol, position };
    }
    
    // Helper method to get existing price format from the page
    getExistingPriceFormat() {
      const priceElements = document.querySelectorAll('.price-item--regular, .price-item--sale');
      if (priceElements.length === 0) return null;
      
      try {
        // Get the first price element that's not a compare price or sale price
        let priceElement = null;
        for (let i = 0; i < priceElements.length; i++) {
          if (!priceElements[i].closest('.price__compare-price') && !priceElements[i].closest('s')) {
            priceElement = priceElements[i];
            break;
          }
        }
        
        if (!priceElement) return null;
        
        const priceText = priceElement.textContent.trim();

        
        // Check if we have a number in the price
        const numericMatch = priceText.match(/[\d]+(?:[.,]\d+)?/);
        if (!numericMatch || !numericMatch[0]) return null;
        
        const numericPart = numericMatch[0];
        const numericIndex = priceText.indexOf(numericPart);
        
        // Get what's before and after the number
        const beforeNumeric = priceText.substring(0, numericIndex).trim();
        const afterNumeric = priceText.substring(numericIndex + numericPart.length).trim();
        
        // Determine currency position and symbol
        let symbol = '';
        let position = 'before'; // Default
        
        if (beforeNumeric && !afterNumeric) {
          symbol = beforeNumeric;
          position = 'before';
        } else if (!beforeNumeric && afterNumeric) {
          symbol = afterNumeric;
          position = 'after';
        } else if (beforeNumeric && afterNumeric) {
          // If both exist, we need to determine which one is the currency symbol
          // Currency symbols are typically non-alphanumeric or 3-letter codes
          const beforeIsSymbol = /^[^\w\d\s]|[A-Z]{3}$/.test(beforeNumeric.trim());
          const afterIsSymbol = /^[^\w\d\s]|[A-Z]{3}$/.test(afterNumeric.trim());
          
          if (beforeIsSymbol && !afterIsSymbol) {
            symbol = beforeNumeric;
            position = 'before';
          } else if (!beforeIsSymbol && afterIsSymbol) {
            symbol = afterNumeric;
            position = 'after';
          } else {
            // If both could be symbols, use the shorter one
            symbol = beforeNumeric.length <= afterNumeric.length ? beforeNumeric : afterNumeric;
            position = beforeNumeric.length <= afterNumeric.length ? 'before' : 'after';
          }
        }
        
        return { 
          symbol, 
          position,
          hasDecimals: numericPart.includes('.') || numericPart.includes(','),
          originalFormat: priceText
        };
      } catch (e) {
        console.error('Error analyzing price format:', e);
        return null;
      }
    }
  
    // Helper method to check if a click is on the X button or its white box area
    isXButtonClick(event) {
      // Check if we have a parent bundle color item that's selected
      const colorItem = event.target.closest('.bundle-color-item.selected');
      if (!colorItem) return false;
      
      // Get the button
      const button = colorItem.querySelector('.bundle-color-select-button');
      if (!button) return false;
      
      // Calculate the area of the white box containing the X
      const rect = button.getBoundingClientRect();
      const buttonX = rect.left;
      const buttonY = rect.top;
      
      // Check if click is within the full 30x30 white box area in the top-right corner
      return (event.clientX >= buttonX + rect.width - 30 && 
              event.clientX <= buttonX + rect.width && 
              event.clientY >= buttonY && 
              event.clientY <= buttonY + 30);
    }
  
    // Listen for variant changes on the product form
    listenForVariantChanges() {
      // Find the variant selectors
      const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
      
      // For dropdown selectors
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', () => {
          const variantId = selector.value;
          this.handleVariantChange(variantId);
        });
      });
      
      // For radio buttons
      document.querySelectorAll('input[type="radio"][name="id"]').forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            const variantId = radio.value;
            this.handleVariantChange(variantId);
          }
        });
      });
      
      // Also try to get the initial variant
      const initialVariantId = this.getCurrentVariantId();
      if (initialVariantId) {
        this.handleVariantChange(initialVariantId);
      }
    }
    
    // Get the currently selected variant ID
    getCurrentVariantId() {
      // Try different selector types
      const variantSelector = document.querySelector('select[name="id"]');
      if (variantSelector) return variantSelector.value;
      
      const variantRadio = document.querySelector('input[type="radio"][name="id"]:checked');
      if (variantRadio) return variantRadio.value;
      
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) return variantInput.value;
      
      return null;
    }
    
    handleVariantChange(variantId) {
      this.state.currentVariantId = variantId;

    
      // --- BEGIN: Optional Color State Backup ---
      const previousOptionalSelections = {};
      Object.entries(this.state.selectedColors || {}).forEach(([position, selected]) => {
        if (position.startsWith('optional-') && selected) {
          previousOptionalSelections[position] = { ...selected };
        }
      });

      // --- END: Optional Color State Backup ---
    
      // Try with exact match first
      if (this.tryUpdateColorCount(variantId)) {
  
        this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
        this.updateBundlePriceDisplay();
        return;
      }
    
      // Try with string version of ID
      const variantIdStr = String(variantId);
      if (this.tryUpdateColorCount(variantIdStr)) {
  
        this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
        this.updateBundlePriceDisplay();
        return;
      }
    
      // Try with embedded quotes (might happen with JSON parsing issues)
      const variantIdQuoted = `\"${variantId}\"`;
      if (this.tryUpdateColorCount(variantIdQuoted)) {
  
        this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
        this.updateBundlePriceDisplay();
        return;
      }
    
      // Manual check through all keys (as a last resort)
      if (this.state.variantColorCounts) {
        const keys = Object.keys(this.state.variantColorCounts);
        for (const key of keys) {
          const cleanKey = key.replace(/\"/g, '').replace(/\"/g, '');
          if (cleanKey === String(variantId)) {
            const colorCount = this.state.variantColorCounts[key];
      
            this.updateRequiredColorCount(colorCount);
            this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
            this.updateBundlePriceDisplay();
            return;
          }
        }
  
  
      } else {
  
      }
      this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
      this.updateBundlePriceDisplay();
    }
    
    // Helper method to try updating color count
    tryUpdateColorCount(variantId) {
      if (!this.state.variantColorCounts) return false;
      

      
      if (this.state.variantColorCounts[variantId] !== undefined) {
        const colorCount = this.state.variantColorCounts[variantId];
  
        this.updateRequiredColorCount(colorCount);
        return true;
      }
      
      return false;
    }
    
    // Update the number of required color boxes
    updateRequiredColorCount(count) {
      this.logColorState('BEFORE updateRequiredColorCount');
      // Make sure count is a valid number
      count = parseInt(count, 10);
      if (isNaN(count) || count < 1) {
        console.error('Invalid color count:', count);
        return;
      }
  
      // Store previous required count for logic
      const prevRequiredCount = this.state.prevRequiredColorCount || 0;
      this.state.prevRequiredColorCount = count;
  

  
      // Get the required colors container
      const requiredColorsContainer = document.querySelector('.bundle-required-colors .bundle-colors-grid');
      if (!requiredColorsContainer) return;
  
      // Update grid class based on count
      if (count >= 4) {
        requiredColorsContainer.classList.add('four-item-grid');
        requiredColorsContainer.classList.add('has-four-or-more-items');
      } else {
        requiredColorsContainer.classList.remove('four-item-grid');
        requiredColorsContainer.classList.remove('has-four-or-more-items');
      }
  
      // Get current boxes
      let currentBoxes = requiredColorsContainer.querySelectorAll('.bundle-color-item');
      let currentCount = currentBoxes.length;
  
      // --- STEP 1: Ensure all required boxes exist ---
      let colorLabelPrefix = this.state.colorLabelPrefix;
      if (count > currentCount) {
        for (let i = currentCount + 1; i <= count; i++) {
          const newItem = document.createElement('div');
          newItem.classList.add('bundle-color-item', 'required-color');
          newItem.dataset.colorPosition = i;
          newItem.innerHTML = `
            <div class="bundle-color-placeholder">
              <button type="button" class="bundle-color-select-button" aria-label="Chooose ${colorLabelPrefix} ${i}" data-prevent-scroll="true">
                <span class="plus-icon">+</span>
              </button>
            </div>
            <div class="bundle-color-name">${colorLabelPrefix} ${i}</div>
          `;
          const button = newItem.querySelector('.bundle-color-select-button');
          if (button) {
            button.addEventListener('click', (event) => {
              if (!newItem.classList.contains('selected')) {
                this.handleColorButtonClick(event);
              }
            });
          }
          requiredColorsContainer.appendChild(newItem);
        }
      } else if (count < currentCount) {
        // Always remove boxes from the end, unselecting if necessary
        for (let i = currentCount; i > count; i--) {
          const box = currentBoxes[i - 1];
          const position = box.dataset.colorPosition;
          
          if (this.state.selectedColors[position]) {
            this.unselectColorFromProduct(position);
          }
          box.remove();
        }
        this.reindexColorBoxes();
        // Clean up state: remove any selectedColors for positions > count
        Object.keys(this.state.selectedColors).forEach(pos => {
          const num = parseInt(pos, 10);
          if (!isNaN(num) && num > count) {
            delete this.state.selectedColors[pos];
          }
        });
      }
  
      // Refresh currentBoxes after any DOM changes
      currentBoxes = requiredColorsContainer.querySelectorAll('.bundle-color-item');
      currentCount = currentBoxes.length;
  
      // --- STEP 2: PROMOTE OPTIONAL TO COMPULSORY IF NEEDED ---
      if (count > prevRequiredCount) {
        // 1. Gather all selected optionals and sort by their position
        const selectedOptionals = Object.entries(this.state.selectedColors)
          .filter(([position, selected]) => position.startsWith('optional-') && selected)
          .sort((a, b) => {
            const aNum = parseInt(a[0].replace('optional-', ''), 10);
            const bNum = parseInt(b[0].replace('optional-', ''), 10);
            return aNum - bNum;
          });
        // 2. Move optionals up to fill compulsory slots (lowest index first)
        let promotedOptionals = [];
        for (let i = 1; i <= count && selectedOptionals.length > 0; i++) {
          if (!this.state.selectedColors[i]) {
            const [optPos, optSel] = selectedOptionals.shift();
            this.state.selectedColors[i] = optSel;
            promotedOptionals.push(optPos);
            // Update UI for compulsory
            this.updateColorItemUI(i, optSel);
            // Remove the old optional color box from DOM
            const optDom = document.querySelector(`.bundle-color-item[data-color-position="${optPos}"]`);
            if (optDom) optDom.remove();
          }
        }
        // 3. Remove all optionals that weren't promoted
        Object.keys(this.state.selectedColors).forEach(pos => {
          if (pos.startsWith('optional-') && !promotedOptionals.includes(pos)) {
            // Remove from state
            delete this.state.selectedColors[pos];
            // Remove from DOM
            const optDom = document.querySelector(`.bundle-color-item[data-color-position="${pos}"]`);
            if (optDom) optDom.remove();
          }
        });
      }
      // --- REMOVE EXCESS COMPULSORY SELECTIONS IF NEEDED ---
      if (count < prevRequiredCount) {
        this.justRemovedCompulsoryColorIds = [];
        for (let i = prevRequiredCount; i > count; i--) {
          if (this.state.selectedColors[i]) {
            // Save the ID for filtering later
            if (this.state.selectedColors[i].id) {
              this.justRemovedCompulsoryColorIds.push(this.state.selectedColors[i].id);
              this.removedColorIds.add(this.state.selectedColors[i].id);
            }
            this.unselectColorFromProduct(i);
          }
        }
      }
  
      // Update action button since the requirements might have changed
      this.updateActionButton();
      // Always update the price display after changing required color count
      this.updateBundlePriceDisplay();
      this.logColorState('AFTER updateRequiredColorCount');
    }
  
    addEventListeners() {
      // Add event listeners for color buttons (empty boxes)
      document.querySelectorAll(this.selectors.colorButtons).forEach(button => {
        button.addEventListener('click', this.handleColorButtonClick.bind(this));
      });
  
      // Unified handler for both the X button clicks and color selection
      document.addEventListener('click', (event) => {
        // First check if this is a click on the X button - if so, handle removal instead of drawer opening
        const clickedOnX = this.isXButtonClick(event);
        if (clickedOnX) {
          // Get the color item and position
          const colorItem = event.target.closest('.bundle-color-item.selected');
          if (colorItem) {
            const position = colorItem.dataset.colorPosition;
            
            if (position) {
              // Prevent default and stop propagation immediately
              event.preventDefault();
              event.stopPropagation();
              
        
              
              // Force remove this color item regardless of state
              this.forceRemoveColorItem(colorItem, position);
              
              // Return false to prevent any other handlers from running
              return false;
            }
          }
        }
        
        // Check if we clicked on the color image or placeholder
        const colorPlaceholder = event.target.closest('.bundle-color-placeholder');
        const colorItem = event.target.closest('.bundle-color-item.selected');
        
        // Only proceed if we clicked on a selected color item and not on the X button area
        if (colorItem && colorPlaceholder && !clickedOnX) {
      
          
          // Get the color position and reopen the drawer for that position
          const position = colorItem.dataset.colorPosition;
          if (position) {
            event.preventDefault();
            
            // Set current color position and open drawer
            this.state.currentColorPosition = position;
            this.openDrawer();
            
            // Determine if this is a required or optional color
            this.state.isRequired = !position.startsWith('optional-');
  
            // Update drawer title
            const drawerTitle = document.querySelector(this.selectors.drawerTitle);
            if (drawerTitle) {
              const positionDisplay = this.state.isRequired ? this.state.currentColorPosition : this.state.currentColorPosition.replace('optional-', '');
              const titleText = this.state.isRequired 
                ? this.state.drawerTitleTemplate.replace('[position]', positionDisplay) 
                : this.state.drawerTitleOptionalTemplate.replace('[position]', positionDisplay);
              drawerTitle.textContent = titleText;
            }
  
            // Load products for the drawer
            this.loadColors();
          }
        }
      }, { capture: true }); // Use capture phase to get event before other handlers
      
      // Add event listener for drawer close button
      const drawerCloseButton = document.querySelector(this.selectors.drawerClose);
      if (drawerCloseButton) {
        drawerCloseButton.addEventListener('click', this.closeDrawer.bind(this));
      }
  
      // Add event listener for drawer overlay
      const drawerOverlay = document.querySelector(this.selectors.drawerOverlay);
      if (drawerOverlay) {
        drawerOverlay.addEventListener('click', this.closeDrawer.bind(this));
      }
      
      // Add event listener for search icon
      const searchIcon = document.querySelector(this.selectors.searchIcon);
      if (searchIcon) {
        searchIcon.addEventListener('click', this.toggleSearchBar.bind(this));
      }
      
      // Add event listener for settings icon (preferences)
      const settingsIcon = document.querySelector('.drawer__icon-btn.settings-icon');
      if (settingsIcon) {
        settingsIcon.addEventListener('click', this.togglePreferenceFilters.bind(this));
      }
      
      // Add event listeners for search input and button
      const searchInput = document.querySelector(this.selectors.searchInput);
      const searchButton = document.querySelector(this.selectors.searchButton);
      
      if (searchInput) {
        searchInput.addEventListener('input', this.handleSearchInput.bind(this));
        // Also handle Enter key press
        searchInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.handleSearchSubmit();
          }
        });
      }
      
      if (searchButton) {
        searchButton.addEventListener('click', this.handleSearchSubmit.bind(this));
      }
      
      // Add event listeners for preference filter options
      document.querySelectorAll('.bundle-filter-option').forEach(option => {
        option.addEventListener('click', this.toggleFilterOption.bind(this));
      });
      
      // Add event listener for clear filters button
      const clearFiltersButton = document.querySelector('.bundle-clear-filters');
      if (clearFiltersButton) {
        clearFiltersButton.addEventListener('click', this.clearAllFilters.bind(this));
      }
  
      // Close drawer on ESC key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.state.drawerOpen) {
          this.closeDrawer();
        }
      });
      
      // Close drawer when clicking outside
      document.addEventListener('mousedown', (event) => {
        const drawer = document.querySelector(this.selectors.bundleDrawer);
        const drawerInner = drawer ? drawer.querySelector('.drawer__inner') : null;
        
        if (this.state.drawerOpen && drawerInner && !drawerInner.contains(event.target)) {
          // Check if we're clicking directly on the drawer (not inner), which counts as outside
          if (event.target === drawer || event.target === overlay) {
            this.closeDrawer();
          }
        }
      });
  
      // Add to cart button
      const addToCartButton = document.querySelector(this.selectors.bundleAddToCart);
      if (addToCartButton) {
        addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
      }
    }
  
    handleColorButtonClick(event) {
      // Prevent default button behavior which can cause page scrolling
      event.preventDefault();
      
      const colorItem = event.currentTarget.closest(this.selectors.colorItems);
      if (!colorItem) return;
  
      this.state.currentColorPosition = colorItem.dataset.colorPosition;
      this.state.isRequired = colorItem.classList.contains('required-color');
  
      // Store current scroll position
      this.state.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  
      // Update drawer title
      const drawerTitle = document.querySelector(this.selectors.drawerTitle);
      if (drawerTitle) {
        const positionDisplay = this.state.isRequired ? this.state.currentColorPosition : this.state.currentColorPosition.replace('optional-', '');
        const titleText = this.state.isRequired 
          ? this.state.drawerTitleTemplate.replace('[position]', positionDisplay) 
          : this.state.drawerTitleOptionalTemplate.replace('[position]', positionDisplay);
        drawerTitle.textContent = titleText;
      }
  
      this.openDrawer();
      this.loadColors();
    }
  
    openDrawer() {
      const drawer = document.querySelector(this.selectors.bundleDrawer);
      if (!drawer) return;
      
      // Set initial position before adding drawer-open class to avoid jumps
      this.state.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.state.scrollPosition}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      // Move the drawer to document.body to ensure it's outside any stacking contexts
      if (drawer.parentElement !== document.body) {
        // Store the original parent for when we close
        this.state.drawerOriginalParent = drawer.parentElement;
        this.state.drawerOriginalNextSibling = drawer.nextSibling;
        
        // Move the drawer to the body (this preserves event listeners)
        document.body.appendChild(drawer);
      }
      
      // Make sure the drawer is fully visible in the DOM before adding animations
      requestAnimationFrame(() => {
        // First make the drawer visible but without inner content slide in
        drawer.classList.add('active');
        this.state.drawerOpen = true;
        document.body.classList.add('bundle-drawer-open');
      });
      
      // Announce drawer open for screen readers
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('class', 'visually-hidden');
      announcement.textContent = 'Color selection drawer opened. Press Escape to close.';
      document.body.appendChild(announcement);
      
      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 1000);
    }
  
    closeDrawer() {
      const drawer = document.querySelector(this.selectors.bundleDrawer);
      if (!drawer) return;
      
      // First remove the active class to start the transitions
      drawer.classList.remove('active');
      this.state.drawerOpen = false;
      document.body.classList.remove('bundle-drawer-open');
      
      // Wait for the CSS transitions to complete before moving the drawer
      setTimeout(() => {
        // If we moved the drawer to body, move it back to original position
        if (this.state.drawerOriginalParent && drawer.parentElement === document.body) {
          // Move the drawer back to its original location (preserving event listeners)
          if (this.state.drawerOriginalNextSibling) {
            this.state.drawerOriginalParent.insertBefore(drawer, this.state.drawerOriginalNextSibling);
          } else {
            this.state.drawerOriginalParent.appendChild(drawer);
          }
          
          // Clear the references
          this.state.drawerOriginalParent = null;
          this.state.drawerOriginalNextSibling = null;
        }
        
        // Improved scroll restoration that prevents any jumping
        const scrollPosition = this.state.scrollPosition;
        
        // Reset body styles completely AFTER setting the scroll position
        if (typeof scrollPosition === 'number') {
          // Remove the fixed positioning styles
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          
          // Use requestAnimationFrame for more reliable timing
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              // Restore the scroll position with instant behavior
              window.scrollTo(0, scrollPosition);
            });
          });
        } else {
          // If no scroll position, just reset the styles
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
        }
        
        // Reset search and preference UI when closing drawer
        this.resetSearchUI();
        this.resetPreferenceUI();
        
        // Reset any category filters
        this.resetCategoryFilters();
      }, 300); // Match this to the CSS transition duration
    }
    
    // New helper method to reset category filters
    resetCategoryFilters() {
      // Remove active class from all category tabs
      const tabs = document.querySelectorAll('.bundle-category-tab');
      tabs.forEach(tab => tab.classList.remove('active'));
      
      // Reset products to show all (if the product grid exists)
      const productGrid = document.querySelector('.bundle-color-product-grid');
      if (productGrid) {
        // Make all products visible again
        const products = productGrid.querySelectorAll('.bundle-color-product');
        products.forEach(product => {
          product.style.display = '';
        });
      }
      

    }
    
    // Toggle the search bar visibility when search icon is clicked
    toggleSearchBar() {
      const searchIcon = document.querySelector(this.selectors.searchIcon);
      const searchContainer = document.querySelector(this.selectors.searchContainer);
      const searchInput = document.querySelector(this.selectors.searchInput);
      const preferenceContainer = document.querySelector('.bundle-preference-container');
      const settingsIcon = document.querySelector('.drawer__icon-btn.settings-icon');
      
      if (!searchContainer || !searchIcon) return;
      
      // Close preferences container if it's open
      if (preferenceContainer && preferenceContainer.classList.contains('active')) {
        preferenceContainer.classList.remove('active');
        settingsIcon.classList.remove('active');
      }
      
      // Toggle the active state
      this.state.searchActive = !this.state.searchActive;
      
      // Update UI
      if (this.state.searchActive) {
        searchContainer.classList.add('active');
        searchIcon.classList.add('active');
        // Focus the input after the animation completes
        setTimeout(() => {
          searchInput.focus();
        }, 300);
      } else {
        searchContainer.classList.remove('active');
        searchIcon.classList.remove('active');
        // Clear search when closing
        this.resetSearch();
      }
    }
    
    // Handle search input as user types
    handleSearchInput(event) {
      this.state.searchQuery = event.target.value.trim().toLowerCase();
      
      // Filter products in real-time as user types
      this.filterProductsBySearch();
    }
    
    // Handle search button click or Enter key press
    handleSearchSubmit() {
      // We already filter in real-time, but this can be used for additional actions
      const searchInput = document.querySelector(this.selectors.searchInput);
      
      if (searchInput) {
        this.state.searchQuery = searchInput.value.trim().toLowerCase();
        this.filterProductsBySearch();
      }
    }
    
    // Filter products based on search query
    filterProductsBySearch() {
      const colorGrid = document.querySelector(this.selectors.colorGrid);
      if (!colorGrid) return;
      
      const products = colorGrid.querySelectorAll('.bundle-color-product');
      const query = this.state.searchQuery;
      
      products.forEach(product => {
        const productTitle = product.querySelector('.bundle-color-product-title');
        const title = productTitle ? productTitle.textContent.toLowerCase() : '';
        
        // Show or hide product based on search match
        if (query === '' || title.includes(query)) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
      
      // Check if we have any visible products
      this.updateNoResultsMessage(colorGrid, products);
    }
    
    // Add or remove 'no results' message
    updateNoResultsMessage(container, products) {
      // Count visible products
      const visibleProducts = Array.from(products).filter(
        product => product.style.display !== 'none'
      ).length;
      
      // Remove existing message if it exists
      const existingMessage = container.querySelector('.bundle-no-results');
      if (existingMessage) {
        existingMessage.remove();
      }
      
      // Add message if no products are visible
      if (visibleProducts === 0 && this.state.searchQuery) {
        const noResults = document.createElement('div');
        noResults.className = 'bundle-no-results';
        noResults.textContent = `No colors found matching "${this.state.searchQuery}"`;
        container.appendChild(noResults);
      }
    }
    
    // Reset search state and UI
    resetSearch() {
      const searchInput = document.querySelector(this.selectors.searchInput);
      if (searchInput) {
        searchInput.value = '';
        this.state.searchQuery = '';
        this.filterProductsBySearch();
      }
    }
    
    // Reset search UI when closing drawer
    resetSearchUI() {
      const searchContainer = document.querySelector(this.selectors.searchContainer);
      const searchIcon = document.querySelector(this.selectors.searchIcon);
      
      if (searchContainer) {
        searchContainer.classList.remove('active');
      }
      
      if (searchIcon) {
        searchIcon.classList.remove('active');
      }
      
      this.resetSearch();
      this.state.searchActive = false;
    }
    
    // Toggle the preference filters panel
    togglePreferenceFilters() {
      // If search is active, hide it first
      if (this.state.searchActive) {
        this.toggleSearchBar();
      }
      
      const settingsIcon = document.querySelector('.drawer__icon-btn.settings-icon');
      const preferenceContainer = document.querySelector('.bundle-preference-container');
      
      if (!preferenceContainer || !settingsIcon) return;
      
      // Toggle the active state
      this.state.preferenceActive = !this.state.preferenceActive;
      
      // Update UI
      if (this.state.preferenceActive) {
        preferenceContainer.classList.add('active');
        settingsIcon.classList.add('active');
      } else {
        preferenceContainer.classList.remove('active');
        settingsIcon.classList.remove('active');
      }
    }
    
    // Handle filter option selection/deselection
    toggleFilterOption(event) {
      const option = event.currentTarget;
      const filterType = option.dataset.filterType; // 'color' or 'style'
      const filterValue = option.dataset.filterValue; // e.g., 'rot', 'glitzer', etc.
      
      if (!filterType || !filterValue) return;
      
      // Toggle the active class
      option.classList.toggle('active');
      
      // Update the active filters state
      const index = this.state.activeFilters[filterType].indexOf(filterValue);
      
      if (index === -1) {
        // Add to active filters
        this.state.activeFilters[filterType].push(filterValue);
        // Set a flag to indicate filters are actively applied
        this.state.filtersApplied = true;
      } else {
        // Remove from active filters
        this.state.activeFilters[filterType].splice(index, 1);
        
        // Check if we have any active filters left
        const hasActiveFilters = 
          this.state.activeFilters.color.length > 0 || 
          this.state.activeFilters.style.length > 0;
        
        // Update the flag
        this.state.filtersApplied = hasActiveFilters;
      }
      
      // Apply the filters to the products
      this.applyFilters();
    }
    
    // Apply all active filters to products
    applyFilters() {
      const colorGrid = document.querySelector(this.selectors.colorGrid);
      if (!colorGrid) return;
      
      const products = colorGrid.querySelectorAll('.bundle-color-product');
      const hasColorFilters = this.state.activeFilters.color.length > 0;
      const hasStyleFilters = this.state.activeFilters.style.length > 0;
      const searchQuery = this.state.searchQuery.toLowerCase();
      
      let visibleCount = 0;
      
      // Log what we're filtering for

      
      products.forEach(product => {
        let matchesColorFilter = !hasColorFilters; // If no color filters, all products match
        let matchesStyleFilter = !hasStyleFilters; // If no style filters, all products match
        
        // Get product title for search filtering
        const productTitle = product.querySelector('.bundle-color-product-title')?.textContent.toLowerCase() || '';
        
        // NEW DIRECT ATTRIBUTE MATCHING FOR COLORS
        if (hasColorFilters) {
          // First try using the direct data attributes we set for each color
          const colorCount = parseInt(product.dataset.productColorCount || '0', 10);
          
          if (colorCount > 0) {
            // For each color filter we're looking for
            for (const activeColor of this.state.activeFilters.color) {
              // Check if this product has the color attribute directly
              const colorAttr = `data-color-${activeColor.toLowerCase().replace(/\s+/g, '-')}`;
              if (product.hasAttribute(colorAttr)) {
                matchesColorFilter = true;
                break; // One match is enough to include this product
              }
              
              // Also check each individual color value
              for (let i = 0; i < colorCount; i++) {
                const colorValue = product.dataset[`productColorValue${i}`];
                if (colorValue && colorValue.toLowerCase() === activeColor.toLowerCase()) {
                  matchesColorFilter = true;
                  break; // One match is enough to include this product
                }
              }
              
              // Break early if we found a match
              if (matchesColorFilter) break;
            }
          } else {
            // Fallback to original method if no individual colors stored
            const productColor = (product.dataset.productColor || '').toLowerCase();
            matchesColorFilter = this.state.activeFilters.color.some(color => {
              return productColor.split(',').map(c => c.trim()).includes(color.toLowerCase());
            });
          }
        }
        
        // NEW DIRECT ATTRIBUTE MATCHING FOR STYLES
        if (hasStyleFilters) {
          // First try using the direct data attributes we set for each style
          const styleCount = parseInt(product.dataset.productStyleCount || '0', 10);
          
          if (styleCount > 0) {
            // For each style filter we're looking for
            for (const activeStyle of this.state.activeFilters.style) {
              // Check if this product has the style attribute directly
              const styleAttr = `data-style-${activeStyle.toLowerCase().replace(/\s+/g, '-')}`;
              if (product.hasAttribute(styleAttr)) {
                matchesStyleFilter = true;
                break; // One match is enough to include this product
              }
              
              // Also check each individual style value
              for (let i = 0; i < styleCount; i++) {
                const styleValue = product.dataset[`productStyleValue${i}`];
                if (styleValue && styleValue.toLowerCase() === activeStyle.toLowerCase()) {
                  matchesStyleFilter = true;
                  break; // One match is enough to include this product
                }
              }
              
              // Break early if we found a match
              if (matchesStyleFilter) break;
            }
          } else {
            // Fallback to original method if no individual styles stored
            const productStyle = (product.dataset.productStyle || '').toLowerCase();
            matchesStyleFilter = this.state.activeFilters.style.some(style => {
              return productStyle.split(',').map(s => s.trim()).includes(style.toLowerCase());
            });
          }
        }
        
        // Check if product matches search query
        const matchesSearch = !searchQuery || productTitle.includes(searchQuery);
        
        // Show or hide product based on filters and search
        const matches = matchesColorFilter && matchesStyleFilter && matchesSearch;
        product.style.display = matches ? '' : 'none';
        
        // For debugging, log why products don't match
        if (!matches) {
    
        }
        
        if (matches) visibleCount++;
      });
      
      // Check if we have any visible products
      this.updateNoResultsMessage(colorGrid, products);
      
      // Log for debugging

    }
    
    // Clear all active filters
    clearAllFilters() {
      // Reset active filters state
      this.state.activeFilters.color = [];
      this.state.activeFilters.style = [];
      this.state.filtersApplied = false;
      
      // Remove active class from all filter options
      document.querySelectorAll('.bundle-filter-option').forEach(option => {
        option.classList.remove('active');
      });
      
      // Apply the reset filters
      this.applyFilters();
    }
    
    // Reset preference UI when closing drawer
    resetPreferenceUI() {
      const preferenceContainer = document.querySelector('.bundle-preference-container');
      const settingsIcon = document.querySelector('.drawer__icon-btn.settings-icon');
      
      if (preferenceContainer) {
        preferenceContainer.classList.remove('active');
      }
      
      if (settingsIcon) {
        settingsIcon.classList.remove('active');
      }
      
      this.state.preferenceActive = false;
    }
  
    async loadColors() {
      const colorGrid = document.querySelector(this.selectors.colorGrid);
      const loading = document.querySelector(this.selectors.loadingOverlay);
      const drawerTitle = document.querySelector(this.selectors.drawerTitle);
      
      // Show loading state
      loading.style.display = 'flex';
      
      // Update the title based on the current color position
      if (drawerTitle) {
        const positionDisplay = this.state.isRequired ? this.state.currentColorPosition : this.state.currentColorPosition.replace('optional-', '');
        const titleText = this.state.isRequired 
          ? this.state.drawerTitleTemplate.replace('[position]', positionDisplay) 
          : this.state.drawerTitleOptionalTemplate.replace('[position]', positionDisplay);
        drawerTitle.textContent = titleText;
      }
      
      if (!colorGrid || !loading) return;
  
      // Show loading state
      loading.style.display = 'flex';
      colorGrid.innerHTML = '';
  
      try {
        // Get collection handle from data attribute
        const bundleSelector = document.querySelector(this.selectors.bundleSelector);
        let collectionId;
        const isOptional = this.state.currentColorPosition && this.state.currentColorPosition.toString().includes('optional');
        
        if (isOptional && this.state.optionalColorsCollection) {
          collectionId = this.state.optionalColorsCollection;
    
        } else {
          collectionId = this.state.colorsCollection;
    
        }
        
        // Debug logging
  
        
        if (!collectionId) {
          console.error('No collection specified for bundle colors');
          colorGrid.innerHTML = '<p class="empty-message">Please select a color collection in the theme editor settings for this product.</p>';
          loading.style.display = 'none';
          return;
        }
  
        // Clean up collection ID/handle
        // Remove any quotes or extra spaces that might have been added in liquid
        collectionId = collectionId.toString().replace(/["']/g, '').trim();
        
        // Fetch products from the collection - handle both IDs and handles
        let fetchUrl;
        
        // First try to find collection by handle (most common)
        if (collectionId.includes('/')) {
          // If it contains a slash, it's probably a full URL - extract just the handle
          const parts = collectionId.split('/');
          collectionId = parts[parts.length - 1].split('?')[0]; // Get last part and remove query params
        }
        
        // Clean up any remaining special characters
        collectionId = collectionId.replace(/[^a-zA-Z0-9-_]/g, '');
        
        // Build the URL
        fetchUrl = `/collections/${encodeURIComponent(collectionId)}?view=bundle-json`;
        
  
  
        
        const response = await fetch(fetchUrl);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch collection data: ${response.status}`);
        }
        
        const text = await response.text();
        
        // Debug log
  
  
        let data;
  
        try {
          // First try to parse as direct JSON
          try {
            data = JSON.parse(text);
      
          } catch (e) {
      
            // If that fails, try to extract JSON from the response (handle Shopify wrapping)
            const jsonMatch = text.match(/\{.*\}/s);
            if (jsonMatch) {
        
              data = JSON.parse(jsonMatch[0]);
            } else {
        
              throw e; // Re-throw to fall back to HTML parsing
            }
          }
        } catch (e) {
    
    
          // Fallback: Create DOM from HTML response and extract product data
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = text;
          
          // Find all products in the HTML
          const products = [];
          const productItems = tempDiv.querySelectorAll('[data-product-id], .product-item');
          
          productItems.forEach(item => {
            const id = item.dataset.productId || item.querySelector('[data-product-id]')?.dataset.productId;
            const title = item.dataset.productTitle || item.querySelector('.product-title, h3, .title')?.textContent?.trim();
            const imgEl = item.querySelector('img');
            const priceEl = item.querySelector('.price, [data-price]');
            
            if (id) {
              products.push({
                id: id,
                title: title || 'Color Option',
                image: imgEl?.src || imgEl?.dataset.src || '',
                price: item.dataset.productPrice || '',
                price_formatted: priceEl?.textContent || '',
                available: (item.dataset.available !== 'false')
              });
            }
          });
  
          // If we found products, use them
          if (products.length > 0) {
            data = { products };
          } else {
            console.error('Could not extract product data from HTML response');
            throw new Error('Invalid collection data format');
          }
        }
  
        // Render products
        if (data && data.products && data.products.length > 0) {
    
          this.renderProductGrid(data.products, colorGrid);
        } else {
    
          colorGrid.innerHTML = '<p class="empty-message">No color products found in this collection.</p>';
        }
      } catch (error) {
        console.error('Error loading colors:', error);
        
        let errorMessage = '';
        if (error.message.includes('404')) {
          errorMessage = `<p class="error-message">Collection not found: "${collectionId}"</p>
                        <p>Please check in your Shopify admin that:</p>
                        <ul>
                          <li>A collection with this ID or handle exists</li>
                          <li>The collection is not private</li>
                          <li>You have selected the correct collection in the theme editor</li>
                        </ul>`;
        } else {
          errorMessage = `<p class="error-message">Error loading colors: ${error.message}</p>
                        <p>Please check if the collection exists and has products.</p>`;
        }
        
        colorGrid.innerHTML = errorMessage;
      } finally {
        loading.style.display = 'none';
      }
    }
  
    renderProductGrid(products, container) {
      // Clear any existing content
      container.innerHTML = '';
      
      // Sort products alphabetically by title for better organization
      const sortedProducts = [...products].sort((a, b) => {
        return a.title.localeCompare(b.title);
      });
      
      // Create the product grid element first
      const productGrid = document.createElement('div');
      productGrid.classList.add('bundle-color-product-grid');
      
      // Get tab labels from the data attributes for theme editor customization
      const bundleSelector = document.querySelector(this.selectors.bundleSelector);
      const manicureLabel = bundleSelector.dataset.manicureLabel || 'Manicure';
      const pedicureLabel = bundleSelector.dataset.pedicureLabel || 'Pedicure';
      const filter3Label = bundleSelector.dataset.filter3Label || '0';
      const filter4Label = bundleSelector.dataset.filter4Label || '0';
      const filter5Label = bundleSelector.dataset.filter5Label || '0';
      
      // Prepare filter tabs HTML
      let tabsHTML = `
        <div class="bundle-category-tabs">
          <button class="bundle-category-tab" data-category="manicure">${manicureLabel}</button>
      `;
      
      // Only add additional tabs if they have valid labels (not 0)
  
      if (pedicureLabel !== '0') {
        tabsHTML += `<button class="bundle-category-tab" data-category="pedicure">${pedicureLabel}</button>`;
      }
      
      if (filter3Label !== '0') {
        tabsHTML += `<button class="bundle-category-tab" data-category="filter3">${filter3Label}</button>`;
      }
      
      if (filter4Label !== '0') {
        tabsHTML += `<button class="bundle-category-tab" data-category="filter4">${filter4Label}</button>`;
      }
      
      if (filter5Label !== '0') {
        tabsHTML += `<button class="bundle-category-tab" data-category="filter5">${filter5Label}</button>`;
      }
      
      tabsHTML += `</div>`;
      
      // Create category tabs at the top
      const categoryTabs = document.createElement('div');
      categoryTabs.classList.add('bundle-color-categories');
      categoryTabs.innerHTML = tabsHTML;
      
      container.appendChild(categoryTabs);
      
      // Add event listeners to the tabs
      const tabs = categoryTabs.querySelectorAll('.bundle-category-tab');
      tabs.forEach(tab => {
        tab.addEventListener('click', (event) => {
          const clickedTab = event.currentTarget;
          const category = clickedTab.dataset.category;
          
          // If the tab is already active, deselect it (show all products)
          if (clickedTab.classList.contains('active')) {
            clickedTab.classList.remove('active');
            this.filterProductsByCategory(products, productGrid, 'all');
          } else {
            // Otherwise, make this tab active and deactivate others
            tabs.forEach(t => t.classList.remove('active'));
            clickedTab.classList.add('active');
            this.filterProductsByCategory(products, productGrid, category);
          }
        });
      });
      
      container.appendChild(productGrid);
      
      // Initially display all products with no category filtering
      this.filterProductsByCategory(products, productGrid, 'all');
    }
    
    // Filter products by category (Manicure or Pedicure)
    filterProductsByCategory(products, grid, category) {
      // Clear the grid before adding filtered products
      grid.innerHTML = '';
      
      // Get the custom tag filters from the data attributes
      const bundleSelector = document.querySelector(this.selectors.bundleSelector);
      const manicureTag = bundleSelector.dataset.manicureTag || 'manicure';
      const pedicureTag = bundleSelector.dataset.pedicureTag || 'pedicure';
      const filter3Tag = bundleSelector.dataset.filter3Tag || '0';
      const filter4Tag = bundleSelector.dataset.filter4Tag || '0';
      const filter5Tag = bundleSelector.dataset.filter5Tag || '0';
      
      // Debug logs to help troubleshoot filtering issues


      
      // Filter products based on the category metafield or tag
      const filteredProducts = category === 'all' 
        ? products 
        : products.filter(product => {
            // Check product's type metafield or tags
            const productType = product.metafields?.bundle?.product_type || '';
            const productTags = product.tags || [];
            
            // Get the specific tag to look for based on selected category
            let tagToMatch = '';
            switch (category) {
              case 'manicure':
                tagToMatch = manicureTag;
                break;
              case 'pedicure':
                tagToMatch = pedicureTag;
                break;
              case 'filter3':
                tagToMatch = filter3Tag !== '0' ? filter3Tag : '';
                break;
              case 'filter4':
                tagToMatch = filter4Tag !== '0' ? filter4Tag : '';
                break;
              case 'filter5':
                tagToMatch = filter5Tag !== '0' ? filter5Tag : '';
                break;
            }
            
            // Debug info for each product during filtering
      
            
            // Check if the product has the category in either metafield or tags
            const matchesMetafield = productType.toLowerCase() === category.toLowerCase();
            const matchesTag = Array.isArray(productTags) && 
                              productTags.some(tag => tag.toLowerCase() === tagToMatch.toLowerCase());
            
            // If we're looking for a specific tag and the product has it, show it
            if (tagToMatch && matchesTag) return true;
            
            // If no specific tag is set, fall back to the default category matching
            if (!tagToMatch) {
              // If no specific categorization, show in all categories
              if (!productType && (!productTags || productTags.length === 0)) return true;
              
              // Match if either metafield or tag matches the category name directly
              return matchesMetafield || 
                    (Array.isArray(productTags) && 
                     productTags.some(tag => tag.toLowerCase() === category.toLowerCase()));
            }
            
            return false;
          });
      
      // Log filtered results

      
      // If no filtered products, show a message
      if (filteredProducts.length === 0) {
        grid.innerHTML = `<p class="empty-message">No ${category} designs found.</p>`;
        return;
      }
      
      // Create the product items
      filteredProducts.forEach(product => {
        const productElement = document.createElement('div');
        productElement.classList.add('bundle-color-product');
        productElement.dataset.productId = product.id;
        productElement.dataset.productTitle = product.title;
        productElement.dataset.productImage = product.image;
        productElement.dataset.productPrice = product.price;
        
        // Add metafield data for color and style filtering
        if (product.metafields) {
          let colorAdded = false;
          let styleAdded = false;
          
          // OPTION 1: Check for color metaobject references (shopify namespace)
          if (product.metafields.shopify && (product.metafields.shopify['--color-pattern'] || product.metafields.shopify['shopify-style-color'])) {
            const colorMeta = product.metafields.shopify['--color-pattern'] || product.metafields.shopify['shopify-style-color'];
            if (Array.isArray(colorMeta)) {
              // Store each individual color label separately for exact matching
              const colorLabels = colorMeta.map(item => item.label).filter(Boolean);
              
              // Store as a comma-separated string for display and fallback
              productElement.dataset.productColor = colorLabels.join(', ');
              
              // Very important: Add each color as a separate data attribute for exact filtering
              colorLabels.forEach((colorLabel, index) => {
                productElement.dataset[`productColorValue${index}`] = colorLabel;
              });
              
              // Store the count for easier iteration
              productElement.dataset.productColorCount = colorLabels.length;
              
              // Add full color data as a JSON string for potential use in rendering
              productElement.dataset.productColorData = JSON.stringify(colorMeta);
              
              // Add data-color-X attributes for CSS selection
              colorLabels.forEach(colorLabel => {
                // Make sure we have a valid string for the attribute name
                if (typeof colorLabel === 'string') {
                  let colorAttr = colorLabel.toLowerCase().replace(/\s+/g, '-');
                  // Further sanitize to ensure valid attribute name
                  colorAttr = colorAttr.replace(/[^a-z0-9-_]/g, '');
                  if (colorAttr) {
                    productElement.setAttribute(`data-color-${colorAttr}`, 'true');
                  }
                }
              });
              
              colorAdded = true;
            } else if (colorMeta) {
              // Fallback if not structured as expected
              productElement.dataset.productColor = colorMeta;
              colorAdded = true;
            }
          }
          
          // OPTION 2: Check for custom.color metafield (custom namespace)
          if (!colorAdded && product.metafields.custom && product.metafields.custom.color) {
            // Get the custom color metafield value
            const customColor = product.metafields.custom.color;
            
            // Make sure we have a string value
            const colorStr = String(customColor || '');
            
            // Store the color value
            productElement.dataset.productColor = colorStr;
            
            // If it's a comma-separated list, parse it, otherwise treat as a single value
            let colorValues = [];
            if (colorStr.includes(',')) {
              colorValues = colorStr.split(',').map(c => c.trim()).filter(Boolean);
            } else if (colorStr.trim()) {
              colorValues = [colorStr.trim()];
            }
            
            // Add each color as a separate data attribute
            colorValues.forEach((colorValue, index) => {
              productElement.dataset[`productColorValue${index}`] = colorValue;
            });
            
            // Store count for easier iteration
            productElement.dataset.productColorCount = colorValues.length;
            
            // Add data-color-X attributes for CSS selection
            colorValues.forEach(colorValue => {
              // Make sure we have a valid string for the attribute name
              if (typeof colorValue === 'string') {
                let colorAttr = colorValue.toLowerCase().replace(/\s+/g, '-');
                // Further sanitize to ensure valid attribute name
                colorAttr = colorAttr.replace(/[^a-z0-9-_]/g, '');
                if (colorAttr) {
                  productElement.setAttribute(`data-color-${colorAttr}`, 'true');
                }
              }
            });
            
            colorAdded = true;
          }
          
          // NEW: Handle object-type color metafields - add after color options
          if (productElement.dataset.productColor === '[object Object]' && product.metafields?.custom?.color) {
            console.warn(`Product ${product.title} has object-type color metafield that needs special handling`);
            
            // Try to handle custom.color as object
            if (typeof product.metafields.custom.color === 'object') {
              const colorObj = product.metafields.custom.color;
              
              // Check for various possible properties (label is what user indicated)
              let colorValue = '';
              
              // First try label property as user indicated
              if (colorObj.label) {
                colorValue = String(colorObj.label).trim();
              } 
              // Fall back to value property
              else if (colorObj.value) {
                colorValue = String(colorObj.value).trim();
              }
              
              // Log the object properties for debugging
        
              
              if (colorValue) {
                productElement.dataset.productColor = colorValue;
                productElement.dataset.productColorValue0 = colorValue;
                productElement.dataset.productColorCount = '1';
                
                // Set attribute for direct filtering
                let colorAttr = colorValue.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '');
                if (colorAttr) {
                  productElement.setAttribute(`data-color-${colorAttr}`, 'true');
                }
                
          
                colorAdded = true;
              }
            }
          }
  
          // OPTION 1: Check for style metaobject references (shopify namespace)
          if (product.metafields.shopify && (product.metafields.shopify['style-pattern'] || product.metafields.shopify['shopify-style-pattern'])) {
            const styleMeta = product.metafields.shopify['style-pattern'] || product.metafields.shopify['shopify-style-pattern'];
            if (Array.isArray(styleMeta)) {
              // Store each individual style label separately for exact matching
              const styleLabels = styleMeta.map(item => item.label).filter(Boolean);
              
              // Store as a comma-separated string for display and fallback
              productElement.dataset.productStyle = styleLabels.join(', ');
              
              // Very important: Add each style as a separate data attribute for exact filtering
              styleLabels.forEach((styleLabel, index) => {
                productElement.dataset[`productStyleValue${index}`] = styleLabel;
              });
              
              // Store the count for easier iteration
              productElement.dataset.productStyleCount = styleLabels.length;
              
              // Add data-style-X attributes for CSS selection
              styleLabels.forEach(styleLabel => {
                // Make sure we have a valid string for the attribute name
                if (typeof styleLabel === 'string') {
                  let styleAttr = styleLabel.toLowerCase().replace(/\s+/g, '-');
                  // Further sanitize to ensure valid attribute name
                  styleAttr = styleAttr.replace(/[^a-z0-9-_]/g, '');
                  if (styleAttr) {
                    productElement.setAttribute(`data-style-${styleAttr}`, 'true');
                  }
                }
              });
              
              styleAdded = true;
            } else if (styleMeta) {
              // Fallback if not structured as expected
              productElement.dataset.productStyle = styleMeta;
              styleAdded = true;
            }
          }
          
          // OPTION 2: Check for custom.style metafield (custom namespace)
          if (!styleAdded && product.metafields.custom && product.metafields.custom.style) {
            // Get the custom style metafield value
            const customStyle = product.metafields.custom.style;
            
            // Make sure we have a string value
            const styleStr = String(customStyle || '');
            
            // Store the style value
            productElement.dataset.productStyle = styleStr;
            
            // If it's a comma-separated list, parse it, otherwise treat as a single value
            let styleValues = [];
            if (styleStr.includes(',')) {
              styleValues = styleStr.split(',').map(s => s.trim()).filter(Boolean);
            } else if (styleStr.trim()) {
              styleValues = [styleStr.trim()];
            }
            
            // Add each style as a separate data attribute
            styleValues.forEach((styleValue, index) => {
              productElement.dataset[`productStyleValue${index}`] = styleValue;
            });
            
            // Store count for easier iteration
            productElement.dataset.productStyleCount = styleValues.length;
            
            // Add data-style-X attributes for CSS selection
            styleValues.forEach(styleValue => {
              // Make sure we have a valid string for the attribute name
              if (typeof styleValue === 'string') {
                let styleAttr = styleValue.toLowerCase().replace(/\s+/g, '-');
                // Further sanitize to ensure valid attribute name
                styleAttr = styleAttr.replace(/[^a-z0-9-_]/g, '');
                if (styleAttr) {
                  productElement.setAttribute(`data-style-${styleAttr}`, 'true');
                }
              }
            });
            
            styleAdded = true;
          }
          
          // NEW: Handle object-type style metafields - add after style options
          if (productElement.dataset.productStyle === '[object Object]' && product.metafields?.custom?.style) {
            console.warn(`Product ${product.title} has object-type style metafield that needs special handling`);
            
            // Try to handle custom.style as object
            if (typeof product.metafields.custom.style === 'object') {
              const styleObj = product.metafields.custom.style;
              
              // Check for various possible properties (label is what user indicated)
              let styleValue = '';
              
              // First try label property as user indicated
              if (styleObj.label) {
                styleValue = String(styleObj.label).trim();
              } 
              // Fall back to value property
              else if (styleObj.value) {
                styleValue = String(styleObj.value).trim();
              }
              
              // Log the object properties for debugging
        
              
              if (styleValue) {
                productElement.dataset.productStyle = styleValue;
                productElement.dataset.productStyleValue0 = styleValue;
                productElement.dataset.productStyleCount = '1';
                
                // Set attribute for direct filtering
                let styleAttr = styleValue.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '');
                if (styleAttr) {
                  productElement.setAttribute(`data-style-${styleAttr}`, 'true');
                }
                
          
                styleAdded = true;
              }
            }
          }
        }
        
        // Check if this product is already selected for the current position
        const isSelected = this.state.selectedColors[this.state.currentColorPosition] && 
                          this.state.selectedColors[this.state.currentColorPosition].id === product.id;
        
        if (isSelected) {
          productElement.classList.add('selected');
        }
        
        // Build product HTML with conditional price display and quick view button
        let productHTML = `
          <div class="bundle-color-product-image">
            <img src="${product.image || ''}" alt="${product.title}" loading="lazy">
            ${!product.available ? `<div class="sold-out-overlay"><span>${this.state.outOfStockText}</span></div>` : ''}
          </div>
          <div class="bundle-color-product-title">${product.title}</div>`;
        
        // Only show price if enabled
        if (this.state.showPrices) {
          productHTML += `<div class="bundle-color-product-price">${product.price_formatted || ''}</div>`;
        }
        
        // Add quick view button if enabled
        if (this.state.showQuickView) {
          productHTML += `<button type="button" class="quick-view-button" data-product-id="${product.id}" data-product-title="${product.title}" data-product-image="${product.image}">${this.state.quickViewButtonText || 'Quick View'}</button>`;
        }
        
        productElement.innerHTML = productHTML;
        
        // Add event listener for selecting a color (when clicking on the product)
        productElement.addEventListener('click', (event) => {
          const removeBtn = event.target.closest('.remove-color-btn');
          const quickViewBtn = event.target.closest('.quick-view-button');
          
          // If clicking on the remove button, unselect instead of select
          if (removeBtn) {
            event.stopPropagation(); // Prevent the parent click from firing
            this.unselectColor(product);
          } 
          // If clicking on quick view button, show modal instead of selecting
          else if (quickViewBtn) {
            event.stopPropagation(); // Prevent the parent click from firing
            this.openQuickViewModal(product);
          } 
          // Otherwise, select the color
          else {
            if (product.available !== false) {
              this.selectColor(product);
            } else {
        
              // Optionally could show a message to the user
            }
          }
        });
        
        grid.appendChild(productElement);
      });
    }
  
    selectColor(product) {
      // Store the selected color in state
      this.state.selectedColors[this.state.currentColorPosition] = {
        id: product.id,
        handle: product.handle, // Always store the handle
        title: product.title,
        image: product.image,
        price: product.price
      };
      
      // Debug log to check what's being selected

      
      // Mark selected product in the grid and unmark others
      const productElements = document.querySelectorAll('.bundle-color-product');
      productElements.forEach(el => {
        if (el.dataset.productId === product.id) {
          el.classList.add('selected');
          // Add remove button if it doesn't exist (X icon)
          const imageContainer = el.querySelector('.bundle-color-product-image');
          if (imageContainer && !imageContainer.querySelector('.remove-color-btn')) {
            const removeBtn = document.createElement('div');
            removeBtn.classList.add('remove-color-btn');
            removeBtn.dataset.productId = product.id;
            removeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="white" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
            
            // Add click event to unselect color
            removeBtn.addEventListener('click', (e) => {
              e.stopPropagation(); // Prevent parent click event
              this.unselectColor(product);
            });
            
            imageContainer.appendChild(removeBtn);
          }
        } else if (el.dataset.productId !== product.id && el.classList.contains('selected')) {
          el.classList.remove('selected');
          // Remove the X button when unselecting
          const removeBtn = el.querySelector('.remove-color-btn');
          if (removeBtn) {
            removeBtn.remove();
          }
        }
      });
      
      // If filters are applied, clear them after selection
      if (this.state.filtersApplied) {
        this.clearAllFilters();
        
        // Also reset any active tab selections
        const categoryTabs = document.querySelectorAll('.bundle-category-tab');
        categoryTabs.forEach(tab => tab.classList.remove('active'));
      }
      
      // We'll check for adding new optional colors after updating the UI
      // This is to ensure that DOM selection state is updated first
      
      // Close the drawer after a short delay (gives user visual feedback)
      setTimeout(() => {
        this.closeDrawer();
        
        // Update the color item UI
        this.updateColorItemUI(this.state.currentColorPosition, product);
        
        // Check if we need to add a new optional color selector - AFTER UI update
        if (this.state.currentColorPosition.startsWith('optional-')) {
          // Use a small additional delay to ensure the DOM has updated
          setTimeout(() => {
            this.maybeAddNewOptionalColorSelector();
          }, 100);
        }
        
        // Update action button
        this.updateActionButton();
        // --- DYNAMIC BUNDLE PRICE LOGIC ---
        this.updateBundlePriceDisplay();
        // --- END ---
      }, 300);
    }
    
    unselectColor(product) {
      // Find which color position this product is selected for
      let positionToUnselect = null;
      
      // Look through all selected colors to find the matching product
      Object.keys(this.state.selectedColors).forEach(position => {
        if (this.state.selectedColors[position] && 
            this.state.selectedColors[position].id === product.id) {
          positionToUnselect = position;
        }
      });
      
      // If we found the position, unselect it
      if (positionToUnselect) {
        this.unselectColorFromProduct(positionToUnselect);
      }
    }
    
    unselectColorFromProduct(position) {
      const colorItem = document.querySelector(`.bundle-color-item[data-color-position="${position}"]`);
      if (colorItem) {
        this.forceRemoveColorItem(colorItem, position);
  
      } else {
        if (this.state.selectedColors[position]) {
          delete this.state.selectedColors[position];
    
          if (position.startsWith('optional-')) {
            setTimeout(() => {
              this.cleanupOptionalColorBoxes();
            }, 100);
          }
          this.updateActionButton();
          // --- DYNAMIC BUNDLE PRICE LOGIC ---
          this.updateBundlePriceDisplay();
          // --- END ---
        }
      }
    }
    
    // New method to force remove a color item regardless of state
    forceRemoveColorItem(colorItem, position) {

      
      // Remove from state if it exists
      if (this.state.selectedColors[position]) {
        delete this.state.selectedColors[position];
      }
      
      // Also check all possible positions in case of reindexing issues
      // This is to ensure that DOM selection state is updated first
      
      // Check our state.selectedColors for any positions starting with 'optional-'
      let selectedOptionalPositions = [];
      
      // Check our state.selectedColors for any positions starting with 'optional-'
      Object.keys(this.state.selectedColors).forEach(pos => {
        if (pos.startsWith('optional-')) {
          selectedOptionalPositions.push(pos);
        }
      });
      

      
      // Also log DOM state for debugging
      const optionalItems = document.querySelectorAll('.bundle-color-item.optional-color');
      optionalItems.forEach((item, index) => {
        const pos = item.dataset.colorPosition;
        const isSelected = item.classList.contains('selected');
  
      });
      
      // Only remove if this is the last selected optional color
      if (selectedOptionalPositions.length === 1 && selectedOptionalPositions[0] === position) {
        // Remove the color item from the DOM
        colorItem.remove();
      }
      
      // Always reset the item's UI
      colorItem.classList.remove('selected');
      
      // Reset the background image
      const placeholder = colorItem.querySelector('.bundle-color-placeholder');
      if (placeholder) {
        placeholder.style.backgroundImage = '';
      }
      
      // Reset the name
      const nameElement = colorItem.querySelector('.bundle-color-name');
      if (nameElement) {
        // Determine if this is a required or optional color
        const isRequired = colorItem.classList.contains('required-color');
        const pos = colorItem.dataset.colorPosition;
        
        if (isRequired) {
          nameElement.textContent = `${this.state.colorLabelPrefix} ${pos}`;
        } else {
          nameElement.textContent = this.state.optionalColorLabel;
        }
      }
      
      // If this is an optional color, clean up the optional boxes
      if (position.startsWith('optional-')) {
  
        // Do it immediately to prevent state issues
        this.cleanupOptionalColorBoxes();
      }
      
      // Update the action button
      this.updateActionButton();
      // --- DYNAMIC BUNDLE PRICE LOGIC ---
      this.updateBundlePriceDisplay();
      // --- END ---
    }
  
    createQuickViewModal() {
      // Create quick view page for the drawer if it doesn't exist already
      const drawer = document.querySelector(this.selectors.bundleDrawer);
      if (!drawer || drawer.querySelector('.quick-view-page')) return;
      
      // Create the HTML for the quick view page with image carousel and select button
      const quickViewHtml = `
        <div class="quick-view-page">
          <div class="quick-view-header">
            <div class="drawer__heading-container">
              <button type="button" class="quick-view-back" aria-label="Back">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path fill="#000000" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
              </button>
              <h2 class="drawer__heading">
                <span class="quick-view-title"></span>
              </h2>
            </div>
          </div>
          <div class="quick-view-content">
            <div class="quick-view-image-container">
              <img class="quick-view-image" src="" alt="" loading="lazy">
              
              <div class="quick-view-navigation">
                <button class="quick-view-nav-button prev-button" aria-label="Previous">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path fill="#000000" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                </button>
                <button class="quick-view-nav-button next-button" aria-label="Next">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path fill="#000000" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                </button>
              </div>
            </div>
            
            <div class="quick-view-dots" role="tablist">
              <button class="quick-view-dot active" aria-selected="true" aria-label="Image 1" data-index="0"></button>
              <button class="quick-view-dot" aria-selected="false" aria-label="Image 2" data-index="1"></button>
              <button class="quick-view-dot" aria-selected="false" aria-label="Image 3" data-index="2"></button>
              <button class="quick-view-dot" aria-selected="false" aria-label="Image 4" data-index="3"></button>
              <button class="quick-view-dot" aria-selected="false" aria-label="Image 5" data-index="4"></button>
            </div>
            
            <button class="quick-view-select-button" type="button">
              <svg width="16" height="16" viewBox="0 0 24 24">
                <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
              <span>Select</span>
            </button>
          </div>
        </div>
      `;
      
      // Append the quick view page to the drawer inner section
      const drawerInner = drawer.querySelector('.drawer__inner');
      if (drawerInner) {
        drawerInner.insertAdjacentHTML('beforeend', quickViewHtml);
        
        // Add event listener to back button
        const backButton = drawerInner.querySelector('.quick-view-back');
        if (backButton) {
          backButton.addEventListener('click', () => this.closeQuickView());
        }
        
        // Add event listeners for navigation buttons
        const prevButton = drawerInner.querySelector('.prev-button');
        const nextButton = drawerInner.querySelector('.next-button');
        if (prevButton && nextButton) {
          prevButton.addEventListener('click', () => this.navigateProductImages('prev'));
          nextButton.addEventListener('click', () => this.navigateProductImages('next'));
        }
        
        // Add event listeners for dots
        const dots = drawerInner.querySelectorAll('.quick-view-dot');
        if (dots.length) {
          dots.forEach(dot => {
            dot.addEventListener('click', () => {
              const index = parseInt(dot.dataset.index, 10);
              this.navigateProductImages(index);
            });
          });
        }
        
        // Add event listener for select button
        const selectButton = drawerInner.querySelector('.quick-view-select-button');
        if (selectButton) {
          selectButton.addEventListener('click', () => {
            this.selectProductFromQuickView();
          });
        }
      }
    }
    
    openQuickViewModal(product) {
      // Get the quick view page element
      const quickViewPage = document.querySelector('.quick-view-page');
      if (!quickViewPage) return;
      
      // Store the current product for the select button
      this.state.currentQuickViewProduct = product;
      
      // Get all images for this product
      this.loadProductImages(product);
      
      // Update content with all product images
      this.updateQuickViewContent(product);
      
      // Reset to first image
      this.state.currentImageIndex = 0;
      
      // Show the quick view page
      quickViewPage.classList.add('active');
    }
    
    closeQuickView() {
      const quickViewPage = document.querySelector('.quick-view-page');
      if (!quickViewPage) return;
      
      // Hide the quick view page
      quickViewPage.classList.remove('active');
    }
    
    navigateProductImages(direction) {
      if (!this.state.productImages || !this.state.productImages.length) return;
      
      const imageCount = this.state.productImages.length;
      let newIndex = this.state.currentImageIndex;
      
      if (direction === 'prev') {
        newIndex = (newIndex - 1 + imageCount) % imageCount;
      } else if (direction === 'next') {
        newIndex = (newIndex + 1) % imageCount;
      } else if (typeof direction === 'number') {
        // Allow direct navigation to a specific index
        newIndex = direction % imageCount;
      }
      
      this.state.currentImageIndex = newIndex;
      
      // Debug log to see what's happening


      
      // Update image src
      const image = document.querySelector('.quick-view-image');
      if (image) {
        // Add a loading animation
        image.classList.add('loading');
        
        // Update the image src
        setTimeout(() => {
          // Set the image source
          image.src = this.state.productImages[newIndex].url;
          
          // Once the image has loaded, remove the loading class
          image.onload = () => {
            image.classList.remove('loading');
          };
        }, 50);
      }
      
      // Update active dot
      const dots = document.querySelectorAll('.quick-view-dot');
      if (dots.length) {
        dots.forEach((dot, index) => {
          if (index === newIndex % dots.length) {
            dot.classList.add('active');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.classList.remove('active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }
    }
    
    loadProductImages(product) {
      // Initialize empty array for product images
      this.state.productImages = [];
      
      // Check if the product has a handle - this means we need to fetch the full product data
      if (product.handle && !product.images) {
  
        // Fetch the product data using the Shopify API
        this.fetchProductImages(product)
          .then(images => {
            if (images && images.length > 0) {
              this.state.productImages = images;
        
              
              // Update the UI with the fetched images
              this.updateQuickViewImagesAfterFetch();
            }
          })
          .catch(error => {
            console.error('Error fetching product images:', error);
            
            let errorMessage = '';
            if (error.message.includes('404')) {
              errorMessage = `<p class="error-message">Collection not found: "${collectionId}"</p>
                            <p>Please check in your Shopify admin that:</p>
                            <ul>
                              <li>A collection with this ID or handle exists</li>
                              <li>The collection is not private</li>
                              <li>You have selected the correct collection in the theme editor</li>
                            </ul>`;
            } else {
              errorMessage = `<p class="error-message">Error loading colors: ${error.message}</p>
                            <p>Please check if the collection exists and has products.</p>`;
            }
            
            // Fallback to single image if fetch fails
            if (product.image) {
              this.state.productImages.push({
                url: product.image,
                alt: product.title || ''
              });
              
              // Update the UI with the fallback image
              this.updateQuickViewImagesAfterFetch();
            }
          });
        
        // Add at least the main image while we wait for the fetch
        if (product.image) {
          this.state.productImages.push({
            url: product.image,
            alt: product.title || ''
          });
        }
      } 
      // If product already has an images array, use that
      else if (product.images && Array.isArray(product.images) && product.images.length > 0) {
  
        product.images.forEach((image, index) => {
          this.state.productImages.push({
            url: typeof image === 'string' ? image : image.src || image.url,
            alt: `${product.title || ''} - Image ${index + 1}`
          });
        });
      } 
      // Fallback - just use the main product image
      else if (product.image) {
  
        this.state.productImages.push({
          url: product.image,
          alt: product.title || ''
        });
      }
      

    }
    
    // Method to fetch product images from Shopify
    async fetchProductImages(product) {
      // If we don't have a handle, we can't fetch the product
      if (!product.handle) {
        console.error('Cannot fetch product images: No product handle provided');
        return [];
      }
      
      try {
        // Create the product JSON URL - this is a standard Shopify endpoint
        // that returns the full product data including all images
        const productJsonUrl = `/products/${product.handle}.js`;
        
  
        const response = await fetch(productJsonUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // Parse the response as JSON
        const productData = await response.json();
        
        // If we have images, process them
        if (productData.images && productData.images.length > 0) {
    
          
          // Extract image URLs and create our image objects
          return productData.images.map((imageSrc, index) => {
            // Clean up the image URL - make sure it's the size we want
            // This uses Shopify's image URL parameters to get a medium-sized image
            const imageUrl = this.getShopifyImageUrl(imageSrc, '800x');
            
            return {
              url: imageUrl,
              alt: `${product.title || ''} - Image ${index + 1}`
            };
          });
        } else {
    
          return [];
        }
      } catch (error) {
        console.error('Error fetching product images:', error);
        return [];
      }
    }
    
    // Helper method to format Shopify image URLs
    getShopifyImageUrl(imageSrc, size = '800x') {
      // If the URL already has a size parameter, replace it
      if (imageSrc.includes('_')) {
        return imageSrc.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, `_${size}.`);
      }
      
      // Otherwise, add the size parameter before the extension
      const lastDotIndex = imageSrc.lastIndexOf('.');
      if (lastDotIndex !== -1) {
        return imageSrc.substring(0, lastDotIndex) + `_${size}` + imageSrc.substring(lastDotIndex);
      }
      
      // If all else fails, just return the original URL
      return imageSrc;
    }
    
    selectProductFromQuickView() {
      if (this.state.currentQuickViewProduct) {
        // Select the product as if clicking it in the grid
        this.selectColor(this.state.currentQuickViewProduct);
        
        // Close the quick view
        this.closeQuickView();
      }
    }
    
    updateQuickViewContent(product) {
      const title = document.querySelector('.quick-view-title');
      const image = document.querySelector('.quick-view-image');
      const selectButton = document.querySelector('.quick-view-select-button');
      
      if (title && product.title) {
        title.textContent = product.title;  // Show the product name instead of 'Quick View'
      }
      
      if (image && this.state.productImages && this.state.productImages.length > 0) {
        // Set to the first image in the carousel
        image.src = this.state.productImages[0].url;
        image.alt = product.title || '';
      }
      
      // Update the select button based on product availability
      if (selectButton) {
        if (product.available === false) {
          // For out-of-stock products: change text, remove SVG, disable button
          selectButton.innerHTML = `<span>${this.state.outOfStockText}</span>`;
          selectButton.disabled = true;
          selectButton.classList.add('disabled', 'sold-out');
        } else {
          // For in-stock products: restore original button with SVG and "Select" text
          selectButton.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 24 24">
              <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
            <span>${this.state.selectButtonText || 'Select'}</span>
          `;
          selectButton.disabled = false;
          selectButton.classList.remove('disabled', 'sold-out');
        }
      }
      
      // Show the appropriate number of dots based on how many images we have
      this.updateQuickViewDots();
    }
    
    updateQuickViewImagesAfterFetch() {
      const image = document.querySelector('.quick-view-image');
      
      // Update image source if we have images and there's an image element
      if (image && this.state.productImages && this.state.productImages.length > 0) {
        // Reset to first image
        this.state.currentImageIndex = 0;
        
        // Update the image src to the first image
        image.src = this.state.productImages[0].url;
      }
      
      // Update dots to match the number of images
      this.updateQuickViewDots();
    }
    
    updateQuickViewDots() {
      const dots = document.querySelectorAll('.quick-view-dot');
      if (!dots.length || !this.state.productImages) return;
      
      const imageCount = this.state.productImages.length;
      
      // Show/hide dots based on number of images
      dots.forEach((dot, index) => {
        if (index < imageCount) {
          dot.style.display = '';  // Show this dot
        } else {
          dot.style.display = 'none';  // Hide extra dots
        }
        
        // Reset active state
        if (index === this.state.currentImageIndex) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
      

    }
  
    updateColorItemUI(position, product) {
      const colorItem = document.querySelector(`.bundle-color-item[data-color-position="${position}"]`);
      if (!colorItem) {
        console.error(`Could not find color item with position: ${position}`);
        return;
      }
      
      // Mark as selected
      colorItem.classList.add('selected');
      
      // Update background image - ensure we're setting a valid URL
      const placeholder = colorItem.querySelector('.bundle-color-placeholder');
      if (placeholder) {
        // Log the image URL for debugging
  
        
        // Make sure we have a valid image URL
        if (product.image && product.image.trim() !== '') {
          placeholder.style.backgroundImage = `url(${product.image})`;
        } else {
          console.warn(`No valid image URL for product: ${product.title}`);
        }
      } else {
        console.error(`Could not find placeholder for position: ${position}`);
      }
      
      // Always update the name element to show the selected product name
      const nameElement = colorItem.querySelector('.bundle-color-name');
      if (nameElement) {
        // Store the original name as a data attribute if we haven't already
        if (!nameElement.dataset.originalText) {
          nameElement.dataset.originalText = nameElement.textContent;
        }
        
        // Update to show the product title
        nameElement.textContent = product.title;
      }
      
      // Log a success message for troubleshooting

    }
  
    // Function to check if we need to add a new optional color selector
    maybeAddNewOptionalColorSelector() {

  
      // Get the bundle colors grid for optional colors
      const optionalSection = document.querySelector('.bundle-optional-section');
      if (!optionalSection) {
        console.error('Could not find optional section element');
        return;
      }
      

      
      const colorsGrid = optionalSection.querySelector('.bundle-colors-grid');
      if (!colorsGrid) {
        console.error('Could not find colors grid in optional section');
        return;
      }
      

      
      // Get all optional color items
      const optionalItems = colorsGrid.querySelectorAll('.bundle-color-item.optional-color');
      
      // Check if we have a maximum number of optional colors set
      const maxOptional = this.state.maxOptionalColors || 3; // Default to 3 if not set
      
      // Count how many optional colors are currently visible
      const visibleCount = optionalItems.length;
      
      // Count how many optional colors are selected - using our state instead of DOM
      // This is to ensure that DOM selection state is updated first
      
      // Check our state.selectedColors for any positions starting with 'optional-'
      let selectedOptionalPositions = [];
      
      // Check our state.selectedColors for any positions starting with 'optional-'
      Object.keys(this.state.selectedColors).forEach(pos => {
        if (pos.startsWith('optional-')) {
          selectedOptionalPositions.push(pos);
        }
      });
      

      
      // Also log DOM state for debugging
      optionalItems.forEach((item, index) => {
        const pos = item.dataset.colorPosition;
        const isSelected = item.classList.contains('selected');
  
      });
      

      
      // Only add a new box when:
      // 1. At least one color is selected (otherwise we don't need a new empty box)
      // 2. We haven't reached the maximum allowed optional colors
      // 3. All current boxes are already selected (no empty boxes available)
      // This ensures we only add a new box when there are no empty boxes left
      const emptyBoxes = Array.from(optionalItems).filter(item => !item.classList.contains('selected'));
      const needsNewBox = selectedOptionalPositions.length > 0 && visibleCount < maxOptional && emptyBoxes.length === 0;
      

      
      if (needsNewBox) {
  
        // Create a new optional color item
        const newPosition = visibleCount + 1;
        const newItem = document.createElement('div');
        newItem.classList.add('bundle-color-item', 'optional-color');
        newItem.dataset.colorPosition = `optional-${newPosition}`;
        
        // Get discount percentage from an existing optional color item
        let discountPercentage = 25; // Default value
        
        // Find the first optional color item to extract the discount percentage
        if (optionalItems.length > 0) {
          const firstOptional = optionalItems[0];
          const discountBadge = firstOptional.querySelector('.discount-badge');
          if (discountBadge) {
            const badgeText = discountBadge.textContent;
            const match = badgeText.match(/-(\d+)%/);
            if (match && match[1]) {
              discountPercentage = parseInt(match[1], 10);
            }
          }
        }
        
        // Use the color label from state that we initialized earlier
        const optionalColorLabel = this.state.optionalColorLabel;
        
        // Set the HTML content for the new item
        newItem.innerHTML = `
          <div class="bundle-color-placeholder">
            <div class="discount-badge">-${discountPercentage}%</div>
            <button type="button" class="bundle-color-select-button" aria-label="Select Optional Design ${newPosition}" data-prevent-scroll="true">
              <span class="plus-icon">+</span>
            </button>
          </div>
          <div class="bundle-color-name">${optionalColorLabel}</div>
        `;
        
        // Add event listener to the button
        const button = newItem.querySelector('.bundle-color-select-button');
        if (button) {
          button.addEventListener('click', (event) => {
            // Only handle click if the color item is not selected yet
            if (!newItem.classList.contains('selected')) {
              this.handleColorButtonClick(event);
            }
          });
        }
        
        // Add to the grid
        colorsGrid.appendChild(newItem);
        
        // Track which optional boxes we've added dynamically so we can remove them later if needed
        this.state.dynamicOptionalBoxes.push(`optional-${newPosition}`);
        
  
        
        // Update the grid layout after adding a new box
        const updatedItems = optionalSection.querySelectorAll('.bundle-color-item.optional-color');
        this.updateOptionalColorsLayout(updatedItems.length);
      }
    }
    
    // Helper function to update the layout of optional colors grid
    updateOptionalColorsLayout(count) {

      
      const optionalSection = document.querySelector('.bundle-optional-section');
      if (!optionalSection) {
        console.error('Optional section container not found!');
        return;
      }
      
      const colorsGrid = optionalSection.querySelector('.bundle-colors-grid');
      if (!colorsGrid) {
        console.error('Colors grid not found in optional section!');
        return;
      }
      

      
      // Apply the 4-column layout if we have 4 or more boxes
      if (count >= 4) {
  
        // Use the direct class for 4+ item layouts
        colorsGrid.classList.add('four-item-grid');
        // Keep the old class for backward compatibility
        colorsGrid.classList.add('has-four-or-more-items');
      } else {
  
        colorsGrid.classList.remove('four-item-grid');
        colorsGrid.classList.remove('has-four-or-more-items');
      }
      

    }
  
    updateActionButton() {
      const button = document.querySelector(this.selectors.bundleAddToCart);
      if (!button) return;
  
      const requiredColorItems = document.querySelectorAll('.bundle-color-item.required-color');
      const selectedRequiredColors = document.querySelectorAll('.bundle-color-item.required-color.selected');
      
      // Clone the button to remove all existing event listeners
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      // Apply custom button colors from theme settings
      if (this.state.cartButtonColor) {
        newButton.style.backgroundColor = this.state.cartButtonColor;
        newButton.style.borderColor = this.state.cartButtonColor;
        
        // Add hover effect
        newButton.addEventListener('mouseenter', () => {
          // Use a slightly darker shade for hover (similar to #3a3a3a hover in base.css)
          newButton.style.backgroundColor = '#3a3a3a';
          newButton.style.borderColor = '#3a3a3a';
        });
        
        newButton.addEventListener('mouseleave', () => {
          // Restore original color on mouse leave
          newButton.style.backgroundColor = this.state.cartButtonColor;
          newButton.style.borderColor = this.state.cartButtonColor;
        });
      }
      
      if (this.state.cartButtonTextColor) {
        newButton.style.color = this.state.cartButtonTextColor;
      }
      
      if (selectedRequiredColors.length < requiredColorItems.length) {
        // Find first unselected required color
        let nextPosition = null;
        let nextColorItem = null;
        requiredColorItems.forEach(item => {
          if (!item.classList.contains('selected') && nextPosition === null) {
            nextPosition = item.dataset.colorPosition;
            nextColorItem = item;
          }
        });
        
        // Use the template from settings to format the button text
        let buttonText = '';
        if (nextPosition) {
          // Replace [position] with the actual position number
          buttonText = this.state.chooseColorTextTemplate.replace('[position]', nextPosition);
        } else {
          buttonText = 'Choose Required Colors';
        }
        newButton.textContent = buttonText;
        
        newButton.classList.add('bundle-select-color-button');
        
        // Make the button clickable and set it to open the drawer for the missing color
        newButton.disabled = false;
        
        // Add event listener to open the drawer for the missing color
        newButton.addEventListener('click', (event) => {
          event.preventDefault();
          
          if (nextColorItem) {
            // Get the button within this color item and trigger its click event to open drawer
            const colorButton = nextColorItem.querySelector('.bundle-color-select-button');
            if (colorButton) {
              colorButton.click();
            }
          }
        });
      } else {
        newButton.textContent = this.state.addToCartButtonText;
        newButton.disabled = false;
        newButton.classList.remove('bundle-select-color-button');
        
        // Add the regular add to cart handler
        newButton.addEventListener('click', this.handleAddToCart.bind(this));
      }
    }
  
    async handleAddToCart() {
      const button = document.querySelector(this.selectors.bundleAddToCart);
      if (!button || button.disabled) return;
  
      // Validate all required colors are selected
      const requiredColorItems = document.querySelectorAll('.bundle-color-item.required-color');
      const selectedRequiredColors = document.querySelectorAll('.bundle-color-item.required-color.selected');
      
      if (selectedRequiredColors.length < requiredColorItems.length) {
        alert('Please select all required colors before adding to cart.');
        return;
      }
  
      // Save original button content (HTML)
      const originalContent = button.innerHTML;
      button.innerHTML = '<span class="atc-spinner" aria-hidden="true"></span>';
      button.disabled = true;
  
      try {
  
        
        // Debug the selected colors data structure
  
        
        // First get the product variant ID (we need the variant, not just the product)
        const variantId = document.querySelector('input[name="id"]')?.value || this.getCurrentVariantId();
  
        
        // If we can't get the variant ID, try to use the first variant of the product
        let mainProductVariantId = variantId;
        if (!mainProductVariantId) {
          // Try to get product ID from container
          const productContainer = document.querySelector('.product-bundle-selector');
          const productId = productContainer?.dataset?.productId;
    
          
          // If we found the product ID, fetch its variants
          if (productId) {
            try {
              // First see if we have the product data in window.meta
              if (window.meta && window.meta.product && window.meta.product.id == productId) {
                if (window.meta.product.variants && window.meta.product.variants.length > 0) {
                  mainProductVariantId = window.meta.product.variants[0].id;
            
                }
              } else {
                // Fetch the product data to get its first variant
                const response = await fetch(`/products/${productId}.js`);
                if (response.ok) {
                  const productData = await response.json();
                  if (productData.variants && productData.variants.length > 0) {
                    mainProductVariantId = productData.variants[0].id;
              
                  }
                }
              }
            } catch (error) {
              console.warn('Error fetching product variants:', error);
            }
          }
        }
        
  
        
        if (!mainProductVariantId) {
          throw new Error('Could not determine product ID');
        }
        
        // Generate a unique ID for this bundle
        const bundleId = Date.now();
        
        // Create an array to hold ALL items we'll add to the cart in a single request
        const allCartItems = [];
        
        // First, add the main product to our cart items array
        allCartItems.push({
          id: parseInt(mainProductVariantId, 10), // Ensure ID is a number
          quantity: 1,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_type': 'main'
          }
        });
        
  
        
        // Process included products (products that come with the kit)
        const includedProducts = document.querySelectorAll('.bundle-included-item');
        const includedItemPromises = [];
        
        if (includedProducts && includedProducts.length > 0) {
    
          
          // Process each included product
          includedProducts.forEach((item, index) => {
            // Try to get the product handle from the item
            const nameElement = item.querySelector('.bundle-included-name');
            if (!nameElement) return;
            
            // PATCH: Get product handle from data attribute if available, else fallback to reconstructing (should always be set)
            let productHandle = item.dataset.productHandle;
            let productTitle = '';
            if (nameElement) {
              productTitle = nameElement.textContent.trim();
            }
            if (!productHandle) {
              // Fallback: reconstruct, but warn
              productHandle = productTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-');
              console.warn('No data-product-handle found; falling back to reconstructed handle:', productHandle);
            }
            
            // Create a promise to fetch product data
            const promise = fetch(`/products/${productHandle}.js`)
              .then(response => {
                if (response.ok) return response.json();
                console.warn(`Could not load included product: ${productTitle}`);
                return null;
              })
              .then(productData => {
                if (productData && productData.variants && productData.variants.length > 0) {
                  // Use the first available variant
                  const variant = productData.variants.find(v => v.available) || productData.variants[0];
            
                  
                  // Check if this variant already exists in our array
                  const existingItemIndex = allCartItems.findIndex(item => item.id === variant.id);
                  if (existingItemIndex !== -1) {
                    // Increase quantity for existing item
                    allCartItems[existingItemIndex].quantity += 1;
              
                  } else {
                    // Add as new item
                    allCartItems.push({
                      id: variant.id,
                      quantity: 1,
                      properties: {
                        '_bundle_id': bundleId,
                        '_bundle_type': 'included',
                        '_position': index + 1
                      }
                    });
                  }
                }
              })
              .catch(error => {
                console.warn(`Error loading included product ${productTitle}:`, error);
              });
            
            includedItemPromises.push(promise);
          });
        } else {
    
        }
        
        // Add selected nail colors to the cart items array using our state.selectedColors
        // which should have the proper product data from our color selection process
        let colorPosition = 1;
        const colorPromises = [];
        
        // Process each color from our state object, which should have proper IDs
        for (const position in this.state.selectedColors) {
          const colorData = this.state.selectedColors[position];
          const colorName = colorData.title;
          const isRequired = position.toString().indexOf('optional') === -1; // If position doesn't contain 'optional'
          
          if (!colorData.id && !colorData.handle) {
            console.warn(`Skipping color with missing data at position ${position}: ${colorName}`);
            continue;
          }
          
          // Always use handle for color product fetches
          let productHandle = colorData.handle || colorData.title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          
          // For required colors, check if we need to add the suffix
          if (isRequired && this.state.requiredHandleSuffix) {
            // Check if handle already has our suffix
            const suffix = `-${this.state.requiredHandleSuffix}`;
            if (!productHandle.endsWith(suffix)) {
              productHandle = `${productHandle}${suffix}`;
        
            }
          }
          
          const promise = fetch(`/products/${productHandle}.js`)
            .then(response => {
              if (response.ok) return response.json();
              console.warn(`Could not load color product: ${colorName}`);
              return null;
            })
            .then(productData => {
              if (productData && productData.variants && productData.variants.length > 0) {
                // Use the first available variant
                const variant = productData.variants.find(v => v.available) || productData.variants[0];
                const variantId = parseInt(variant.id, 10);
          
                // Store the variant ID for future use
                this.state.selectedColors[position].variantId = variantId;
                
                // Check if this variant already exists in our array AND has the same bundle type (required/optional)
                // This prevents optional colors from stacking with required colors
                const existingItemIndex = allCartItems.findIndex(item => 
                  item.id === variantId && 
                  item.properties['_bundle_type'] === (isRequired ? 'required' : 'optional')
                );
                
                if (existingItemIndex !== -1) {
                  // Increase quantity for existing item only if they're the same type (required/optional)
                  allCartItems[existingItemIndex].quantity += 1;
            
                } else {
                  // Create properties object first with just the type and position
                  const itemProperties = {
                    '_bundle_type': isRequired ? 'required' : 'optional',
                    '_position': colorPosition
                  };
                  
                  // Only add _bundle_id for required items, not for optional items
                  if (isRequired) {
                    itemProperties['_bundle_id'] = bundleId;
                  }
                  
                  // Add as new item
                  allCartItems.push({
                    id: variantId,
                    quantity: 1,
                    properties: itemProperties
                  });
                }
                
                colorPosition++;
              }
            })
            .catch(error => {
              console.warn(`Error loading color product ${colorName}:`, error);
            });
          
          colorPromises.push(promise);
        }
        
        // Wait for all the color-related promises too
        await Promise.all(colorPromises);
        
        // Wait for any included product data to be fetched
        await Promise.all(includedItemPromises);
        
  
        
        // Reorder items so optional items come first, main product second, then required colors and included items
        const optionalItems = allCartItems.filter(item => item.properties['_bundle_type'] === 'optional');
        const mainProduct = allCartItems.filter(item => item.properties['_bundle_type'] === 'main');
        const requiredItems = allCartItems.filter(item => item.properties['_bundle_type'] === 'required');
        const includedItems = allCartItems.filter(item => item.properties['_bundle_type'] === 'included');
        
        // Create the new ordered array with correct sequence: optional first, main product second, then required, then included
        const orderedCartItems = [...optionalItems, ...mainProduct, ...requiredItems, ...includedItems];
        
  
        
        // Get the cart drawer to access its sections
        const cartDrawer = document.querySelector('cart-drawer');
        
        // Prepare the cart add request with sections parameter
        const requestBody = { items: orderedCartItems };
        let sectionsParam = '';
        
        // If we can get sections information from the cart drawer, add it to the request
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const sections = cartDrawer.getSectionsToRender().map(section => section.id);
          if (sections.length > 0) {
            sectionsParam = `?sections=${sections.join(',')}&sections_url=${window.location.pathname}`;
          }
        } else {
          // Fallback - use standard sections for cart drawer
          sectionsParam = '?sections=cart-drawer,cart-icon-bubble&sections_url=' + window.location.pathname;
        }
        
        // Add ALL items to the cart in a single request
        const cartResponse = await fetch('/cart/add.js' + sectionsParam, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(requestBody)
        });
        
        if (!cartResponse.ok) {
          const errorData = await cartResponse.json().catch(() => ({}));
          throw new Error(errorData.description || `Error adding bundle to cart: ${cartResponse.status}`);
        }
  
        const responseData = await cartResponse.json();
  
        
        // Show a success message
        const addToCartButton = document.querySelector('.bundle-add-to-cart-button');
        if (addToCartButton) {
          const originalText = addToCartButton.textContent || 'Add Bundle to Cart';
          addToCartButton.textContent = 'Added to Cart ✓';
          addToCartButton.classList.add('added-to-cart');
          
          // Reset button text after 2 seconds
          setTimeout(() => {
            addToCartButton.textContent = originalText;
            addToCartButton.classList.remove('added-to-cart');
          }, 2000);
        }
        
        // Update and open the cart drawer using the theme's native method
        if (cartDrawer) {
          // Make sure any open color selection drawer is closed
          this.closeDrawer();
          
          // Remove 'is-empty' class if present
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
          
          // Use the theme's built-in rendering method - this is the key!
          if (typeof cartDrawer.renderContents === 'function') {
            try {
              cartDrawer.renderContents(responseData);
            } catch (drawerError) {
              console.warn('Error rendering cart drawer contents:', drawerError);
              // If rendering fails, fall back to opening the drawer directly
              cartDrawer.open();
            }
          } else {
            // If renderContents isn't available, just open the drawer
            cartDrawer.open();
          }
        } else {
          // Fallback - redirect to cart
          window.location.href = '/cart';
        }
        
        // Clear all selected colors after adding to cart
        this.clearAllSelections();
      } catch (error) {
        console.error('Error adding bundle to cart:', error);
        alert(`There was an error adding your bundle to cart: ${error.message}. Please try again.`);
      } finally {
        // Restore button
        button.innerHTML = originalContent;
        button.disabled = false;
      }
    }
    
    // New method to clear all selections
    clearAllSelections() {

      
      // Reset the state
      this.state.selectedColors = {};
      
      // Clear all selected colors in the UI
      const selectedItems = document.querySelectorAll('.bundle-color-item.selected');
      selectedItems.forEach(item => {
        // Remove selected class
        item.classList.remove('selected');
        
        // Reset background image
        const placeholder = item.querySelector('.bundle-color-placeholder');
        if (placeholder) {
          placeholder.style.backgroundImage = '';
        }
        
        // Reset the name
        const nameElement = item.querySelector('.bundle-color-name');
        if (nameElement) {
          // Determine if this is a required or optional color
          const isRequired = item.classList.contains('required-color');
          const position = item.dataset.colorPosition;
          
          if (isRequired) {
            nameElement.textContent = `${this.state.colorLabelPrefix} ${position}`;
          } else {
            nameElement.textContent = this.state.optionalColorLabel;
          }
        }
      });
      
      // Clean up any extra optional color boxes
      this.cleanupOptionalColorBoxes();
      
      // Update the action button
      this.updateActionButton();
      // --- DYNAMIC BUNDLE PRICE LOGIC ---
      this.updateBundlePriceDisplay();
      // --- END ---
    }
  
    async addItemToCart(id, quantity, properties) {
      try {
  
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(id, 10), // Ensure ID is a number
            quantity: quantity,
            properties: properties
          })
        });
  
        if (!response.ok) {
          // Try to get error details from the response
          const errorData = await response.json().catch(() => ({}));
          console.error('Cart error response:', errorData);
          
          // Create a meaningful error message
          const errorMessage = errorData.description || errorData.message || `HTTP ${response.status}: Error adding item ${id} to cart`;
          throw new Error(errorMessage);
        }
  
        const result = await response.json();
  
        return result;
      } catch (error) {
        console.error(`Failed to add item ${id} to cart:`, error);
        throw error; // Re-throw to be handled by the caller
      }
    }
    
    // Helper function to reindex all color boxes after adding or removing boxes
    reindexColorBoxes() {
      // Reindex required color boxes
      const requiredColorsContainer = document.querySelector('.bundle-required-colors .bundle-colors-grid');
      if (requiredColorsContainer) {
        const requiredBoxes = requiredColorsContainer.querySelectorAll('.bundle-color-item');
        requiredBoxes.forEach((box, index) => {
          const newPosition = index + 1;
          const oldPosition = box.dataset.colorPosition;
          
          // Skip if position hasn't changed
          if (oldPosition === String(newPosition)) {
            return;
          }
          
          // Update position attribute
          box.dataset.colorPosition = newPosition;
          
          // Update the name
          const nameElement = box.querySelector('.bundle-color-name');
          if (nameElement) {
            nameElement.textContent = `${this.state.colorLabelPrefix} ${newPosition}`;
          }
          
          // Update button label
          const button = box.querySelector('.bundle-color-select-button');
          if (button) {
            button.setAttribute('aria-label', `Choose ${this.state.colorLabelPrefix} ${newPosition}`);
          }
          
          // Update state if this was a selected color
          if (this.state.selectedColors[oldPosition]) {
            const colorData = this.state.selectedColors[oldPosition];
            this.state.selectedColors[newPosition] = colorData;
            delete this.state.selectedColors[oldPosition];
            
            // If it's a selected color, update the name to show product title
            if (nameElement && colorData.title) {
              nameElement.textContent = colorData.title;
            }
          }
        });
      }
      
      // Also reindex optional color boxes if needed
      const optionalColorsContainer = document.querySelector('.bundle-optional-section .bundle-colors-grid');
      if (optionalColorsContainer) {
        const optionalBoxes = optionalColorsContainer.querySelectorAll('.bundle-color-item');
        // Build a new selectedColors object for optionals to ensure clean reindexing
        const newSelectedColors = {};
        optionalBoxes.forEach((box, index) => {
          const newIndex = index + 1;
          const oldPosition = box.dataset.colorPosition.replace('optional-', '');
          const oldKey = `optional-${oldPosition}`;
          const newKey = `optional-${newIndex}`;
  
          // Update position attributes
          box.dataset.colorPosition = newKey;
  
          // Only update the name if it's not already selected (showing a product title)
          if (!box.classList.contains('selected')) {
            const nameElement = box.querySelector('.bundle-color-name');
            if (nameElement) {
              // Restore the original name from data attribute if available
              if (nameElement.dataset.originalText) {
                nameElement.textContent = nameElement.dataset.originalText;
              } else {
                // Fallback to default text
                nameElement.textContent = this.state.optionalColorLabel;
              }
            }
          }
  
          // Update button label
          const button = box.querySelector('.bundle-color-select-button');
          if (button) {
            button.setAttribute('aria-label', `Select ${this.state.optionalColorLabel} ${newIndex}`);
          }
  
          // Update state if this was a selected color
          if (this.state.selectedColors[oldKey]) {
            const colorData = this.state.selectedColors[oldKey];
            newSelectedColors[newKey] = colorData;
          }
        });
        // Remove all old optional keys from state and set the new ones
        Object.keys(this.state.selectedColors)
          .filter(key => key.startsWith('optional-'))
          .forEach(key => { delete this.state.selectedColors[key]; });
        Object.assign(this.state.selectedColors, newSelectedColors);
      }
    }
    
    // Clean up optional color boxes after removing a color
    cleanupOptionalColorBoxes() {

      
      // Get all optional color boxes
      const optionalBoxes = Array.from(document.querySelectorAll(`${this.selectors.colorItems}.optional-color`));

      
      if (optionalBoxes.length === 0) return;
      
      // First filter out the selected boxes
      const selectedBoxes = [];
      const emptyBoxes = [];
      
      // Categorize boxes as selected or empty
      optionalBoxes.forEach(box => {
        if (box.classList.contains('selected')) {
          selectedBoxes.push(box);
        } else {
          emptyBoxes.push(box);
        }
      });
      

      
      // Keep all the selected boxes and exactly one empty box
      const boxesToKeep = [...selectedBoxes];
      
      // Add exactly one empty box if needed
      if (emptyBoxes.length > 0) {
        boxesToKeep.push(emptyBoxes[0]);
      } else if (selectedBoxes.length < this.state.maxOptionalColors) {
        // If we don't have any empty boxes, but we need one, create a new one
        const newEmptyBox = document.createElement('div');
        newEmptyBox.classList.add('bundle-color-item', 'optional-color');
        newEmptyBox.dataset.colorPosition = `optional-${selectedBoxes.length + 1}`;
        
        newEmptyBox.innerHTML = `
          <div class="bundle-color-placeholder">
            <div class="discount-badge">-${this.getDiscountPercentage()}%</div>
            <button type="button" class="bundle-color-select-button" aria-label="Select Optional Color">
              <span class="plus-icon">+</span>
            </button>
          </div>
          <div class="bundle-color-name">${this.state.optionalColorLabel}</div>
        `;
        
        // Add event listener to the button
        const button = newEmptyBox.querySelector('.bundle-color-select-button');
        if (button) {
          button.addEventListener('click', (event) => {
            // Only handle click if the color item is not selected yet
            if (!newEmptyBox.classList.contains('selected')) {
              this.handleColorButtonClick(event);
            }
          });
        }
        
        boxesToKeep.push(newEmptyBox);
      }
      
      // Remove all other boxes
      optionalBoxes.forEach(box => {
        if (!boxesToKeep.includes(box)) {
    
          box.remove();
        }
      });
      
      // Find the optional section container - this is critical to ensure boxes stay in the right section
      const optionalSection = document.querySelector('.bundle-optional-section');
      
      if (!optionalSection) {
        console.warn('Optional section container not found!');
        return;
      }
      
      // Get the grid container
      const colorsGrid = optionalSection.querySelector('.bundle-colors-grid');
      if (!colorsGrid) {
        console.warn('Colors grid not found in optional section!');
        return;
      }
      

      
      // Detach all boxes we want to keep from their current position
      boxesToKeep.forEach(box => {
        if (box.parentNode) {
          box.parentNode.removeChild(box);
        }
      });
      
      // Now add them back to the OPTIONAL section in the right order
      boxesToKeep.forEach(box => {
        colorsGrid.appendChild(box);
      });
      
      // Then reindex the remaining boxes

      this.reindexColorBoxes();
      
      // Update the grid layout classes based on the new box count

      this.updateOptionalColorsLayout(boxesToKeep.length);
      
      // Check if we need to add a new optional box
      this.maybeAddNewOptionalColorSelector();
      
      // Ensure our click handlers are properly registered after reindexing
      const newButtons = optionalSection.querySelectorAll('.bundle-color-select-button');
      newButtons.forEach(button => {
        // Remove existing listeners to avoid duplicates
        const newButton = button.cloneNode(true);
        if (button.parentNode) {
          button.parentNode.replaceChild(newButton, button);
        }
        
        // Add fresh event listener
        newButton.addEventListener('click', this.handleColorButtonClick.bind(this));
      });
    }
  
    // Calculate the total price of selected colors (required + optional)
    calculateBundleTotalPrice() {
      let total = 0;
      Object.values(this.state.selectedColors).forEach(selected => {
        if (selected && selected.price) {
          const priceNum = parseInt(selected.price, 10);
          if (!isNaN(priceNum)) total += priceNum;
        }
      });
      return total;
    }
  
    // Update the price display on the product page to include bundle total
    updateBundlePriceDisplay() {
      // Guard: Ensure currentVariantId is set
      if (!this.state.currentVariantId) {
        return;
      }
      const mainProductPrice = this.getVariantPriceById(this.state.currentVariantId);
      if (mainProductPrice === null) {
        this.priceUpdatePending = true;
        return;
      }
      this.priceUpdatePending = false;

      // Calculate optional bundle total as before
      const bundleTotal = this.calculateOptionalBundleTotalPrice();
      
      console.log(`DEBUG - Main product price: ${mainProductPrice}, Bundle total: ${bundleTotal}`);
      
      // Calculate combined display price
      const displayPrice = mainProductPrice + bundleTotal;
      console.log(`DEBUG - Final display price: ${displayPrice}`);
  
      const dynamicPriceContainer = document.getElementById('bundle-dynamic-price');
      const template = document.getElementById('bundle-dynamic-price-template');
      const mainPriceContainer = document.querySelector('.product-page-price');
      if (!dynamicPriceContainer || !template || !mainPriceContainer) {
  
        return;
      }
  
      if (bundleTotal > 0) {
  
        // Find the regular and sale price spans
        const priceSpans = mainPriceContainer.querySelectorAll('.price-item--regular, .price-item--sale');
        priceSpans.forEach(span => {
          // Only update if not inside a compare-at block or <s>
          if (span.closest('.price__compare-price') || span.closest('s')) {
      
            return;
          }
          span.textContent = this.getFormattedPrice(displayPrice);
          span.setAttribute('data-bundle-price', 'true');
    
        });
        // Optionally, add a class to indicate bundle price is active
        mainPriceContainer.classList.add('bundle-price-active');
        // Hide the dynamic price container if it exists
        if (dynamicPriceContainer) dynamicPriceContainer.style.display = 'none';
        mainPriceContainer.style.display = '';

      } else {
        // Optional bundle total is 0, show original price
        // Remove bundle price indicators
        const priceSpans = mainPriceContainer.querySelectorAll('.price-item--regular, .price-item--sale');
        priceSpans.forEach(span => {
          if (span.hasAttribute('data-bundle-price')) {
            // Restore original price from productJson
            const mainProductPrice = this.getVariantPriceById(this.state.currentVariantId);
            if (mainProductPrice !== null) {
              span.textContent = this.getFormattedPrice(mainProductPrice);
            }
            span.removeAttribute('data-bundle-price');
          }
        });
        mainPriceContainer.classList.remove('bundle-price-active');
        if (dynamicPriceContainer) dynamicPriceContainer.style.display = 'none';
        mainPriceContainer.style.display = '';

      }
      
      // Also update the sticky add to cart price
      const stickyPriceContainer = document.querySelector('.sticky-atc__price');
      if (stickyPriceContainer) {
  
        const stickyPriceSpans = stickyPriceContainer.querySelectorAll('.price-item--regular, .price-item--sale');
        stickyPriceSpans.forEach(span => {
          // Only update if not inside a compare-at block or <s>
          if (span.closest('.price__compare-price') || span.closest('s')) {
            return;
          }
          span.textContent = this.getFormattedPrice(displayPrice);
          span.setAttribute('data-bundle-price', 'true');
    
        });
      } else {
  
      }
    }
  
    // Only sum prices for optional (not mandatory) products
    calculateOptionalBundleTotalPrice() {
      let totalExact = 0;
      
      // Get all optional colors
      const optionalColors = Object.entries(this.state.selectedColors)
        .filter(([position, selected]) => selected && selected.price && position.startsWith('optional-'))
        .map(([position, selected]) => ({
          position,
          cents: this.parsePriceToCents(selected.price),
          originalPrice: selected.price
        }))
        .filter(item => !isNaN(item.cents));
      
      // Apply 25% discount to ALL optional designs
      optionalColors.forEach(item => {
        // All optional colors get 25% discount - keep exact decimal value
        const discountedPrice = item.cents * 0.75; // 25% off, preserve decimals
        // Force log with more precision to debug rounding issues
        console.log(`DEBUG - Item cents: ${item.cents}, discounted exact: ${discountedPrice}, as fixed: ${discountedPrice.toFixed(2)}`);
        totalExact += discountedPrice;
      });
      
      // Force a tiny extra amount to ensure proper rounding
      if (totalExact % 1 > 0 && totalExact % 1 < 0.01) {
        totalExact += 0.01; // Add a tiny bit to force proper rounding
      }
      
      console.log(`DEBUG - Total exact: ${totalExact}, with toFixed(2): ${totalExact.toFixed(2)}, rounded up: ${Math.ceil(totalExact)}`);
      
      // Round up at the very end to ensure we catch partial cents
      return Math.ceil(totalExact);
    }
  
    selectColor(product) {
      // Store the selected color in state
      this.state.selectedColors[this.state.currentColorPosition] = {
        id: product.id,
        handle: product.handle, // Always store the handle
        title: product.title,
        image: product.image,
        price: product.price
      };

      // ... existing code ...
      setTimeout(() => {
        this.closeDrawer();
        this.updateColorItemUI(this.state.currentColorPosition, product);
        if (this.state.currentColorPosition.startsWith('optional-')) {
          setTimeout(() => {
            this.maybeAddNewOptionalColorSelector();
          }, 100);
        }
        this.updateActionButton();
        // --- DYNAMIC BUNDLE PRICE LOGIC ---
        this.updateBundlePriceDisplay();
        // --- END ---
      }, 300);
    }
  
    unselectColorFromProduct(position) {
      const colorItem = document.querySelector(`.bundle-color-item[data-color-position="${position}"]`);
      if (colorItem) {
        this.forceRemoveColorItem(colorItem, position);
  
      } else {
        if (this.state.selectedColors[position]) {
          delete this.state.selectedColors[position];
    
          if (position.startsWith('optional-')) {
            setTimeout(() => {
              this.cleanupOptionalColorBoxes();
            }, 100);
          }
          this.updateActionButton();
          // --- DYNAMIC BUNDLE PRICE LOGIC ---
          this.updateBundlePriceDisplay();
          // --- END ---
        }
      }
    }
  
    parsePriceToCents(priceStr) {
      if (typeof priceStr === 'number') return Math.round(priceStr * 100);
      if (!priceStr) return 0;
      let cleaned = priceStr.replace(/[^0-9.,\s]/g, '').trim();
      // If comma is decimal (e.g. '5,00'), convert to dot
      if (/,[0-9]{2}$/.test(cleaned)) cleaned = cleaned.replace(',', '.');
      // Remove all commas except decimal
      if ((cleaned.match(/\./g) || []).length > 1) cleaned = cleaned.replace(/\./g, '');
      if ((cleaned.match(/,/g) || []).length > 1) cleaned = cleaned.replace(/,/g, '');
      const floatVal = parseFloat(cleaned);
      return isNaN(floatVal) ? 0 : Math.round(floatVal * 100);
    }
  
    // NEW: Restore Optional Color Selections After Variant Change
    restoreOptionalSelections(previousOptionalSelections, excludeIds = []) {
      this.logColorState('BEFORE restoreOptionalSelections');
      if (!previousOptionalSelections || Object.keys(previousOptionalSelections).length === 0) {
  
        return;
      }
      Object.entries(previousOptionalSelections).forEach(([position, selected]) => {
        if (this.removedColorIds.has(selected.id)) {
          // Do not restore this color if it was removed due to variant logic
    
          return;
        }
        if (excludeIds.includes(selected.id)) {
    
          return;
        }
        const colorItem = document.querySelector(`.bundle-color-item[data-color-position="${position}"]`);
        if (colorItem) {
          this.state.selectedColors[position] = { ...selected };
          this.updateColorItemUI(position, selected);
    
        } else {
          if (this.state.selectedColors[position]) {
            delete this.state.selectedColors[position];
      
          }
        }
      });
      // Clean up any optional selections in state that do not have a corresponding DOM box
      Object.keys(this.state.selectedColors).forEach(position => {
        if (position.startsWith('optional-')) {
          const colorItem = document.querySelector(`.bundle-color-item[data-color-position="${position}"]`);
          if (!colorItem) {
            delete this.state.selectedColors[position];
      
          }
          // Remove from state if in removedColorIds
          if (this.state.selectedColors[position] && this.removedColorIds.has(this.state.selectedColors[position].id)) {
            delete this.state.selectedColors[position];
            if (colorItem) colorItem.remove();
      
          }
        }
      });
      this.logColorState('AFTER restoreOptionalSelections');
    }
    
    // Fetch product JSON for accurate variant pricing
    fetchProductJson() {
      // Try to get product handle from state, fallback to URL
      const handle = this.state.productHandle || window.location.pathname.split('/').filter(Boolean).pop().split('?')[0];
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(data => {
          this.productJson = data;
    
          if (this.priceUpdatePending) {
      
            this.updateBundlePriceDisplay();
          }
        })
        .catch(e => {
          console.error('Failed to fetch product JSON', e);
        });
    }
  
    // Get variant price by ID from loaded product JSON
    getVariantPriceById(variantId) {
      if (!this.productJson || !this.productJson.variants) return null;


      const variant = this.productJson.variants.find(v => v.id == variantId);
      if (!variant) {
  
        return null;
      }
      return parseInt(variant.price, 10); // price in cents
    }
  
    logColorState(context) {



    }
  
    handleVariantChange(variantId) {
      this.logColorState('BEFORE handleVariantChange');
      this.state.currentVariantId = variantId;

    
      // --- BEGIN: Optional Color State Backup ---
      const previousOptionalSelections = {};
      Object.entries(this.state.selectedColors || {}).forEach(([position, selected]) => {
        if (position.startsWith('optional-') && selected) {
          previousOptionalSelections[position] = { ...selected };
        }
      });

      // --- END: Optional Color State Backup ---
    
      // Try with exact match first
      if (this.tryUpdateColorCount(variantId)) {
  
        this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
        this.updateBundlePriceDisplay();
        return;
      }
    
      // Try with string version of ID
      const variantIdStr = String(variantId);
      if (this.tryUpdateColorCount(variantIdStr)) {
  
        this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
        this.updateBundlePriceDisplay();
        return;
      }
    
      // Try with embedded quotes (might happen with JSON parsing issues)
      const variantIdQuoted = `\"${variantId}\"`;
      if (this.tryUpdateColorCount(variantIdQuoted)) {
  
        this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
        this.updateBundlePriceDisplay();
        return;
      }
    
      // Manual check through all keys (as a last resort)
      if (this.state.variantColorCounts) {
        const keys = Object.keys(this.state.variantColorCounts);
        for (const key of keys) {
          const cleanKey = key.replace(/\"/g, '').replace(/\"/g, '');
          if (cleanKey === String(variantId)) {
            const colorCount = this.state.variantColorCounts[key];
      
            this.updateRequiredColorCount(colorCount);
            this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
            this.updateBundlePriceDisplay();
            return;
          }
        }
  
  
      } else {
  
      }
      this.restoreOptionalSelections(previousOptionalSelections, this.justRemovedCompulsoryColorIds);
      this.updateBundlePriceDisplay();
      this.logColorState('AFTER handleVariantChange');
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.product-bundle-selector')) {
      new ProductBundle();
    }
  });
  
  // Re-initialize when the section is updated in the theme editor
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product-bundle-selector')) {
      new ProductBundle();
    }
  });
  